<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

      const encryptedText = this.CryptoJS.AES.encrypt("Hi There!", 'secret key 123').toString()
      const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto) => {
        return this.CryptoJS.AES.encrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto) => {
        return this.CryptoJS.AES.decrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf, num_cand) => {

        let candidato = {CPF: cpf, NUMEROINSC: num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-', '') * 7919;
        codigo_meio = codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0, 5)) * parseInt(candidato.NUMEROINSC.replace('-', '')) * 13 + '_'
            + String.fromCharCode(65 + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[1]))
            + String.fromCharCode(parseInt(codigo_meio[4] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[7] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[7]))
            + '-'
            + String.fromCharCode(parseInt(codigo_meio[0] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))
            + String.fromCharCode(parseInt(codigo_meio[5] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[8]))
            + '_'
            + String.fromCharCode(parseInt(codigo_meio[2] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[6]))
            + String.fromCharCode(parseInt(codigo_meio[6] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))

        return codigo_arquivo + '.pdf';
      }


      let cands = [
            {
              "num_cand": "U2FsdGVkX1/sCEjy9sLtIH4Ivq6lOw7tKwGiknFg+cQ=",
              "cpf": "U2FsdGVkX18P2Q02jnM7qSCpG5/rZBrJGc2UK/d+1hs="
            }, {
            "num_cand": "U2FsdGVkX1+oeUrW1gepugO7BxzBBFO4do7GjyyjeWQ=",
            "cpf": "U2FsdGVkX1/kW2Rk0GxDAggwBixuSAy8o+CQBE29zH8="
          }, {
            "num_cand": "U2FsdGVkX1/+7U4yzQLNAGnyl64pVs2jUrJKZEJHhsA=",
            "cpf": "U2FsdGVkX19EwgeqZL7BKpj2huJzi8ufnr9VIspnwIk="
          }, {
            "num_cand": "U2FsdGVkX1/mszv0T29tEV0TqPAEXntu/YhA6jauGbM=",
            "cpf": "U2FsdGVkX1/dV0av2KrETItn0K2trsFfMja510gEFOE="
          }, {
            "num_cand": "U2FsdGVkX1+/+Bgk3w6K9xCCzPy5opp5+3Q/iDcsoZ4=",
            "cpf": "U2FsdGVkX18GUDmLESmryv8lYwHu/vkfFRavbFNmBFg="
          }, {
            "num_cand": "U2FsdGVkX1/aTDwezT3GHDFOVw3FholeX/mSas9DI30=",
            "cpf": "U2FsdGVkX18R+yCMh+CelPl7kzi3hxAXujrCUrXGmhM="
          }, {
            "num_cand": "U2FsdGVkX1/MopsugYfkIz20fviY0Bq7WyXw05ZlwLE=",
            "cpf": "U2FsdGVkX1/08LSyTHMw19hallBdKqgQYCHdWKZcEr4="
          }, {
            "num_cand": "U2FsdGVkX18MhWeJiAf5x1AEoTF9stj1M2LXwEBUkv0=",
            "cpf": "U2FsdGVkX19GlAZG0ervCj2j4Iy2UPb389oxJXA+tTQ="
          }, {
            "num_cand": "U2FsdGVkX19kV6pPMJIWMC3Znrbft2t7tyYTuwB4C94=",
            "cpf": "U2FsdGVkX19XeGNimaPNYofJxfBoWYJ0LQkHId0Ynls="
          }, {
            "num_cand": "U2FsdGVkX1+VPPdVfOEsNlD93HneYXWU5UudBCreW+s=",
            "cpf": "U2FsdGVkX1+xZGjRtvA35lJn2z/pGtBIR7MpRf888d4="
          }, {
            "num_cand": "U2FsdGVkX18whchLWbnqkca8g3pn4PSedu63rI1I+e4=",
            "cpf": "U2FsdGVkX1/t71T1AXLjEwSijH/Uxut6n7x3gncIpt4="
          }, {
            "num_cand": "U2FsdGVkX18nkyPpvpagasCufVUbpjddR4m/g0MfsGw=",
            "cpf": "U2FsdGVkX19C891l5Pj6cg+se60bRVefQ0a9I6AMv7A="
          }, {
            "num_cand": "U2FsdGVkX1/zCX/+ybJ1xLt1EvDvWC4jb2WiBXgNjeY=",
            "cpf": "U2FsdGVkX19wg/5JXbHGDr09rFKEG2eNl76rZNTWhwY="
          }, {
            "num_cand": "U2FsdGVkX192IGB8fhHZsQ3FFsDfj1HtVKgLe2hyqFY=",
            "cpf": "U2FsdGVkX1+27nL+Ub/K1SWtX3Q8osbQ9r4oyiH/VF4="
          }, {
            "num_cand": "U2FsdGVkX1/pxNpDzQZn1AyepTCSYqs7t8ET0nV6tK0=",
            "cpf": "U2FsdGVkX18MM48D3RBvETpLWJ9Yyi7s4Lkxtpy9tGE="
          }, {
            "num_cand": "U2FsdGVkX1+wVkmlXZQwwV7wGOz50XsUSjINLZyYwMk=",
            "cpf": "U2FsdGVkX18ngDa1nUldhnWUQsX5gOvli3Sa0i79fvc="
          }, {
            "num_cand": "U2FsdGVkX18k+clCdIU4hLPgDwwcAGeShR9WZDePnB4=",
            "cpf": "U2FsdGVkX194fc7iT7kTnUlaH+NtKuehcaRJaS8fEGg="
          }, {
            "num_cand": "U2FsdGVkX1+LXnUqK50uf8ODLJf6X3fSqt/RJdRPI54=",
            "cpf": "U2FsdGVkX18z+h5pEaQ1Tw1pSAzX5woKkR0zU8Wl990="
          }, {
            "num_cand": "U2FsdGVkX19PkV1tw90cg96sBB7gdysNjfsPwfqgZkI=",
            "cpf": "U2FsdGVkX19XL0D5mDRhMP2r4AfRHYKQTPl+MJqDi3g="
          }, {
            "num_cand": "U2FsdGVkX19bXpggn1z1XWMaynmac/Ozip/DcMSIdn4=",
            "cpf": "U2FsdGVkX19jJQvOIzMLO39Tu15afRTdcmEh98EJyX0="
          }, {
            "num_cand": "U2FsdGVkX1/YYy0RLehZuITbgoPkuyE/ljzefrEdu9Q=",
            "cpf": "U2FsdGVkX1+IsRfBX1ZdXF5hG0Jus9it2dFS4qLBjQU="
          }, {
            "num_cand": "U2FsdGVkX19aAR7WwTmfTM9vfFQTkT7apZG8m+j1dfU=",
            "cpf": "U2FsdGVkX19wtfwrzy9LMiAaJWm/v3XRPEOBcYihajM="
          }, {
            "num_cand": "U2FsdGVkX185+IkdsHnROGV+Ci2uB3z3PvPkdcd/9V8=",
            "cpf": "U2FsdGVkX1+Jl3jBmLSub/WFOVJEThXu93VXaN9s6v0="
          }, {
            "num_cand": "U2FsdGVkX18AEp6wFT9L/y61DJcLfdMIaHySddd16MU=",
            "cpf": "U2FsdGVkX18HxU3oGNhQ8Ma9ll3JTtioiw3ThW6C+0I="
          }, {
            "num_cand": "U2FsdGVkX1+df3V+mosMU7rtfb5kpo03bSasmpOj3ow=",
            "cpf": "U2FsdGVkX1/6UjQEZYmSvRDFLOemH02eIXELvL8/bNA="
          }, {
            "num_cand": "U2FsdGVkX19/NRITc1kGsUkQqS1qY7w/rmCwA78CGog=",
            "cpf": "U2FsdGVkX180wEI0XhB+ft3Z1YxHo3DXfDpauGe64Yo="
          }, {
            "num_cand": "U2FsdGVkX19TgEcU7r8f/Iuy3pP133T4rrJ1o1qAmnk=",
            "cpf": "U2FsdGVkX1+xEzxkCsk+N8rycGbX7mhQ+n16dMd3uTw="
          }, {
            "num_cand": "U2FsdGVkX1+FWQG5VuE3e4JLMAqZjhk8U04dFmINeVA=",
            "cpf": "U2FsdGVkX18kIyeL3C/+u1ZW6s4Xb8QLSfzz/XMDlM8="
          }, {
            "num_cand": "U2FsdGVkX18/czFR/emy1ak1C/Tu4uW/TL90LevYjEk=",
            "cpf": "U2FsdGVkX18RvEVMifRGpXGaW6HD1Vb6viHHjfrYqL8="
          }, {
            "num_cand": "U2FsdGVkX1/QtZqO3R4YwSxBkPunySaQmwrcouc9eYk=",
            "cpf": "U2FsdGVkX1+mkYxwMzE0bRG5WPFjcfhDtSNstAw+Wpc="
          }, {
            "num_cand": "U2FsdGVkX18yv6RTvuC/FZ4BWQa2nz0xIKBLgiRbH9o=",
            "cpf": "U2FsdGVkX1/qtFTOKnjgm7Aj7kytw5jdzf7cOFrjDaI="
          }, {
            "num_cand": "U2FsdGVkX1/cPBxscYgtNHjS/hV8bokUfKft2CrbtPc=",
            "cpf": "U2FsdGVkX19NOQULwBqn7Qbtyj75ve2MFf6lT1ljZwM="
          }, {
            "num_cand": "U2FsdGVkX1+V90kzMXlPeYbs+Y1F6DvcU3tmDp8xikI=",
            "cpf": "U2FsdGVkX18kXPFcB+p3CFnQDaVm7n6yAkm2fwoQ3n0="
          }, {
            "num_cand": "U2FsdGVkX19M+y9bmpvx+eMc6S5z4JbbCNJW+TTqGD4=",
            "cpf": "U2FsdGVkX1/276FSLjqiPX0+mr+ExRfr/lmw1DPF4O0="
          }, {
            "num_cand": "U2FsdGVkX18/KKCmSV27cWMtG7G6dnuPW8v4+y6gPCo=",
            "cpf": "U2FsdGVkX18XEEFaon0rQzXYenYWuUOVI1Np8Rk2jvY="
          }, {
            "num_cand": "U2FsdGVkX18cxEhSzWStBRY8gSQ+UyxWK0a4OlrDU6c=",
            "cpf": "U2FsdGVkX19H+heJ0O12O5J0kRC6Hptv8DgrqJk9Fbk="
          }, {
            "num_cand": "U2FsdGVkX18NYzk8FUg00Qa6O5aoPDbaQtEcaBB249g=",
            "cpf": "U2FsdGVkX1/zy0dCMXoDF0iyeUEKWdymCjVbaHfR6Mo="
          }, {
            "num_cand": "U2FsdGVkX19WIMealAImBktXzg7Pvy9FWPXcJ+DmA2o=",
            "cpf": "U2FsdGVkX18KfQLPnErl3L8D6Uu7OIv/4hAAMFMiWe8="
          }, {
            "num_cand": "U2FsdGVkX18vHtMP5cJFjCZYajj00ycLdUHa9PV5iPA=",
            "cpf": "U2FsdGVkX1+CrXrRdjs0luMNOUVqCdnA9XYoGm5DeTU="
          }, {
            "num_cand": "U2FsdGVkX18wxUteWDmPWYQQKXeXhbEgzqVuqiY4Vd4=",
            "cpf": "U2FsdGVkX1+NjiV1ywpJSqCm+TyiOSGfyX1u2ssrM4Y="
          }, {
            "num_cand": "U2FsdGVkX182VQr/N7Y7NKgjlCai3ehxVEXRGGlmQck=",
            "cpf": "U2FsdGVkX18WfME/W8kjVFRfqR9LA3T7Aiiz3gEkrA8="
          }, {
            "num_cand": "U2FsdGVkX19e0JpPS8bITCBZji5JHjIeMG2bWWUaQZY=",
            "cpf": "U2FsdGVkX1/2FadkAilsgPSigyRPxT3swCwl0xVjzRs="
          }, {
            "num_cand": "U2FsdGVkX1/33PjM/3cL/qvXU2NNkNDXVH5P6+tnlJc=",
            "cpf": "U2FsdGVkX19U+vD+SLEgT2FpNyoan3Bslhf9dXbwwrQ="
          }, {
            "num_cand": "U2FsdGVkX1+D92eoIoKaoHk12OSSvu3zlqpGdDsvh68=",
            "cpf": "U2FsdGVkX18lB3cikEsnB59CA2mFkgseKfmTB1/Gpvo="
          }, {
            "num_cand": "U2FsdGVkX19flJCm981Yn4O0mz8NtjdwzL6qeejFkNw=",
            "cpf": "U2FsdGVkX18EdgiG7GFNCb7Oq+cxfnjPGHr9+xVsPK8="
          }, {
            "num_cand": "U2FsdGVkX19Sghwc078DoQo5aTGyzDrV3SnfLqJkEvY=",
            "cpf": "U2FsdGVkX19aAa14lsFOrQjSluoR+m1uQcy1i26iW/4="
          }, {
            "num_cand": "U2FsdGVkX18YyJuip8pNvO6SliisccOqtK9Vi6DkwwI=",
            "cpf": "U2FsdGVkX191MwxLan7O91g+Y05q4Wtl5SsWzA0S+uw="
          }, {
            "num_cand": "U2FsdGVkX1/gu8+mpKptCGrfj5fa+boXJHI7aEyIhvs=",
            "cpf": "U2FsdGVkX1+5TjfeK0YR/aAxr9/JtbP+/NiQqoxpvNg="
          }, {
            "num_cand": "U2FsdGVkX18I9Rc3IolJxCKaHDjUCG6fWPGc4LqgJhU=",
            "cpf": "U2FsdGVkX18rQZG4F3S1JIq5f72boiqWxOYKlU2jbg8="
          }, {
            "num_cand": "U2FsdGVkX1/dNe5PL7CqEscOZLPCoOxiy0iusrTtpn4=",
            "cpf": "U2FsdGVkX1/E27UtwN1021ecfwx04E31mkrRmy3BIqM="
          }, {
            "num_cand": "U2FsdGVkX19ZJWkawlr/1E6oGrBLYJhfp8vc3CiQAHA=",
            "cpf": "U2FsdGVkX1/Ac8lr0FuY8BMzgUm3yVd0nVX5b8ngdG0="
          }, {
            "num_cand": "U2FsdGVkX19jDgqVZgh9gv2hIc2+Z5GiANg0+fez6bg=",
            "cpf": "U2FsdGVkX1+GimDx3XV5KVedc9/MkMcCqnza/zGc1CQ="
          }, {
            "num_cand": "U2FsdGVkX1+gvt9sZjBqgYvcq/xmCT8P6Rc/wgHlviw=",
            "cpf": "U2FsdGVkX1/6u/qfq/0GK3FndSTeU6gtaHSUtCpSP2E="
          }, {
            "num_cand": "U2FsdGVkX1+kil57nN46j/rq0r0XjPV9hP6a0pNqdCI=",
            "cpf": "U2FsdGVkX1+N1BK7I181bBW7pjysS8CzQwytbJnTEak="
          }, {
            "num_cand": "U2FsdGVkX19FkRmUc2q8K0UdhVH77zC8FtjwXKOf31o=",
            "cpf": "U2FsdGVkX19xs1UMguIwyGdxpQN2ObIuAAhzYAHSEtQ="
          }, {
            "num_cand": "U2FsdGVkX18D8JrQatoUMXycvNAjAeVO2T4aiFYTSzw=",
            "cpf": "U2FsdGVkX1/bYJVdF7/6jj1ECiLGTpdpkDS3PdEXxSM="
          }, {
            "num_cand": "U2FsdGVkX1/+owwvFIM1vocLKJPg29sLBm/v5D6wySk=",
            "cpf": "U2FsdGVkX18E/AgyozVdey+hltphjgivAl/E1Oyn1ZU="
          }, {
            "num_cand": "U2FsdGVkX1/jIAAzSoF6dNKYZduzk3Hviexsn+VsMs4=",
            "cpf": "U2FsdGVkX18S3kW7kMV4eI/rrv2V/gV/Usnlj9AS9OM="
          }, {
            "num_cand": "U2FsdGVkX1/ebFyIYeTwfFHAtVzJzwhr5jN7xJdNVG0=",
            "cpf": "U2FsdGVkX1/fVIt6I/vUhNTAUwi+Rprj0Ce8MBgF04E="
          }, {
            "num_cand": "U2FsdGVkX1/Ehx0d73viJ/XXs+J4fa51xGUMUjfwAeA=",
            "cpf": "U2FsdGVkX18ORTnQH18YR/7QXsMLXIJxWyuX9mM/q+Q="
          }, {
            "num_cand": "U2FsdGVkX19e+jXTepUmqVw3IEBiR9dCtzVx40SOPbc=",
            "cpf": "U2FsdGVkX187iownidKeib7ZoLFW/o+3yddkfqqoYVM="
          }, {
            "num_cand": "U2FsdGVkX1+mVXyrQ6Sxk+lOaSc35grlVHENgW3EfCY=",
            "cpf": "U2FsdGVkX19QGgGRXzL+FQYfxK3hS3Jg+5CBSsJ2W0w="
          }, {
            "num_cand": "U2FsdGVkX18kopJQuu3BGlui6ZI39Wb1K37VcgmORO0=",
            "cpf": "U2FsdGVkX197UGd03WfIEpXDORUu5wv2ygdHaja1ACs="
          }, {
            "num_cand": "U2FsdGVkX1+nOB6L4CbATk7z8jvfh5ru34reiqgYXFI=",
            "cpf": "U2FsdGVkX1/2UF0FCLMP4L57/cByOaSB4Qrm94MXX0Y="
          }, {
            "num_cand": "U2FsdGVkX19acJUnDHwYIQ9Gr6lEIXQC+E/nwHzn6kE=",
            "cpf": "U2FsdGVkX19MVoAfy74JVrM0/IOqOqntSomdPrTCX5k="
          }, {
            "num_cand": "U2FsdGVkX19Gjr7HVXHhnFKXCJKZJ0mTTyJNZKIbLmM=",
            "cpf": "U2FsdGVkX1/uT7sw1BBqeCUL5znYHvUPGqQeAlJg0F0="
          }, {
            "num_cand": "U2FsdGVkX18qsY/Oj6dxy9N+8KvWivyAunXaKQTkiV8=",
            "cpf": "U2FsdGVkX18ihyyuRPY6ZktFGUu3lmK9vgsZ00xSeIY="
          }, {
            "num_cand": "U2FsdGVkX1+yuZvAdBy9H8M7NxGyPIM7Ijxr3qZOuu0=",
            "cpf": "U2FsdGVkX1/0rp3L2K1GX/wd+rLhktmBjE5WbfWhB6s="
          }, {
            "num_cand": "U2FsdGVkX19ASEhdQNWCTXQW8RgfMoqvBdSxLAkhI3U=",
            "cpf": "U2FsdGVkX1+cEhqJCWH+cekXHyXHXUYYyfInWb7HrJA="
          }, {
            "num_cand": "U2FsdGVkX1+SgRB49GMUtMweHc4pp8SoMtTC6RgkfHM=",
            "cpf": "U2FsdGVkX1+2Mfh6UcOqOopaoh4Aj094KkNAtjZQKXM="
          }, {
            "num_cand": "U2FsdGVkX1/m5J50ForfsBg+2BcA8nlONmUM5t1VBkM=",
            "cpf": "U2FsdGVkX1+9mm6DKHrZc0zxv+cW0Sue9wh1E234nKQ="
          }, {
            "num_cand": "U2FsdGVkX19jYleZY81syn9UoP6SbXYqRiAacdJVwwU=",
            "cpf": "U2FsdGVkX18ZKbnfm86jq058Vj5wJtzPqkQY8ZELTYI="
          }, {
            "num_cand": "U2FsdGVkX18Gi/IVobpirnJwo9vaMYgvwYrhvDTUDco=",
            "cpf": "U2FsdGVkX1/kcICk4+8nY84xltSAhPrkPN6rOl3Ne4o="
          }, {
            "num_cand": "U2FsdGVkX19NvH2q7qBG8mCBR38484TGJwEpe+VarlY=",
            "cpf": "U2FsdGVkX184CX+CCEQsoZ54nkit5W7wtn4gbuBPRqI="
          }, {
            "num_cand": "U2FsdGVkX1/fLdqub41LZXXKEh0fhTR8hCecsBa0h2g=",
            "cpf": "U2FsdGVkX1/vnYRFy8TZ00XT9PxZ339+aJJNK00+9cY="
          }, {
            "num_cand": "U2FsdGVkX19m54AiVGce6046ZtRYKUHn5/GIugo/U5Q=",
            "cpf": "U2FsdGVkX18s3mV8dS4aNcBXD02PsqK124qFWQhiR/w="
          }, {
            "num_cand": "U2FsdGVkX18FMiVbruKxeuMKRYkJMPV6sENzhZATHiY=",
            "cpf": "U2FsdGVkX18zy+TTpJbkLPBwuWxoZ98oWwNQ9pKx16o="
          }, {
            "num_cand": "U2FsdGVkX1/iPrBhu5erwHOIx1iKDNaNVy3W+DS9RoA=",
            "cpf": "U2FsdGVkX1/kJpvaj1vUF2qlPIbVeYrBdstBONwaeR0="
          }, {
            "num_cand": "U2FsdGVkX19xMy3/v67Gv4xILjTjrHDQy+PARSj+tJg=",
            "cpf": "U2FsdGVkX1/woy/iFVDzARgI1H+sfayhIl51ZP3zco8="
          }, {
            "num_cand": "U2FsdGVkX199ueEP/vuKPyOYepIcV3g+gArwHDr46Gc=",
            "cpf": "U2FsdGVkX1+QzIBRdde8lcQdpeVP27h9npfpWdxZS6w="
          }, {
            "num_cand": "U2FsdGVkX1+4WDEaonKL4DCoFZr/d18G+Nivh2g9Ilc=",
            "cpf": "U2FsdGVkX1/vAu53Q3YYPNe+Xk1V4nKNyA6ISYqhG48="
          }, {
            "num_cand": "U2FsdGVkX18FFLsP0DTU1+xSJRz1qS7HSVDFquG2+iw=",
            "cpf": "U2FsdGVkX1/rA62O6NA1REoEQvmWYdXHqhzr+jUjT40="
          }, {
            "num_cand": "U2FsdGVkX18hbTlPE6SjyNC/C/UrNDnDvB6PqiMKp9I=",
            "cpf": "U2FsdGVkX1+yG+MaY8XOqHLWjFDf4R8mE0pdO5pCoyw="
          }, {
            "num_cand": "U2FsdGVkX18ZngytDM9NqPBAq8wYO6CmzbTKlHiojMQ=",
            "cpf": "U2FsdGVkX1/ihXHjEGskr1XoD5efuAPuVsSKGmu+sjg="
          }, {
            "num_cand": "U2FsdGVkX1+mpd1TJNYoOZE3X2nHLzQxDBY2zZ3+A0U=",
            "cpf": "U2FsdGVkX19JDbFOXA5l+NfdqYIEcfdxuGSC4z8rz/Y="
          }, {
            "num_cand": "U2FsdGVkX1+OhXZka21lcUGuqA9Ii6DAFKcpjBhTw0E=",
            "cpf": "U2FsdGVkX189vyT27TkRofUr2PghCpkWiJGeRpJdPMk="
          }, {
            "num_cand": "U2FsdGVkX1+SnnGUGiUe8gqRoD2zfMVmm+fNFbo7DM0=",
            "cpf": "U2FsdGVkX18gBDo7awexVLKuVpknRshU5Kuy6ETqUbo="
          }, {
            "num_cand": "U2FsdGVkX196v/32bvkhhxzSC9+cU5nB0+gM2lJlu50=",
            "cpf": "U2FsdGVkX1/gQfpoxni0AXDDV4auphDPhnN6b7se3UY="
          }, {
            "num_cand": "U2FsdGVkX18Gz4Hz87RieBmE7A2F0p6cxOd7a8ZcPH4=",
            "cpf": "U2FsdGVkX1+cIvKDmTBuJFup75fJfC8aJiilOjHNr1g="
          }, {
            "num_cand": "U2FsdGVkX1+YnGSzPC91dHrP19TRGqYNb/4g7XDpVBo=",
            "cpf": "U2FsdGVkX1+kmMwMNka5AqPF0mOQhAPC7aSQy7TU16I="
          }, {
            "num_cand": "U2FsdGVkX197hhl1KHdep/UuM6jFv9RHYzznCFdoDOY=",
            "cpf": "U2FsdGVkX1/EOHE0qg+C/gPkU1YoeIIQxf6kIQoyIng="
          }, {
            "num_cand": "U2FsdGVkX1+Gyrm9ZsGWgCuAbHsFi3Xelu2fqBHbtI8=",
            "cpf": "U2FsdGVkX1+Rf1kDpWkxWPFNhIoVvZeAoVyAyLBTpmM="
          }, {
            "num_cand": "U2FsdGVkX18ZGC4gby979Oz8bTAsIZ4lTnomqWH4Yx8=",
            "cpf": "U2FsdGVkX1/PcNVwCnFbJQzEHN7F6yYnFHuBj2HobJ8="
          }, {
            "num_cand": "U2FsdGVkX18ERwLw9l00ga0Dmt1Gu7gX5o9GK4mQ/P4=",
            "cpf": "U2FsdGVkX19YtKp63UyfiuEStBgKVP5qIB8MDwHJQBY="
          }, {
            "num_cand": "U2FsdGVkX1+OFp96ITH/gGq0q8WAD5ubTHgxhKdZBnw=",
            "cpf": "U2FsdGVkX18raVANMQk3QutVN/qe+pLM8gZ26KeJX/8="
          }, {
            "num_cand": "U2FsdGVkX1/Q76R0lqOeEvmn5zcEspf3Qdi3hH9TJAA=",
            "cpf": "U2FsdGVkX1/NBZ12l2Y629X5HKDJI2u2LV3RWx140Zc="
          }, {
            "num_cand": "U2FsdGVkX1/guBcLsSSK56ox0rndqdWcLjHiWgyZCMs=",
            "cpf": "U2FsdGVkX18Ac/U3wXYKyhQ/ppw5SqS6WnzT23yhMxU="
          }, {
            "num_cand": "U2FsdGVkX19moTSJM0TqPjUxRcxZWnIv9nf4ExqynVw=",
            "cpf": "U2FsdGVkX1/0YSsgzLTrlaKbT3IphXdNemWNb6FX3pg="
          }, {
            "num_cand": "U2FsdGVkX1/sHCE+RzN5UEgFV/bDF7LQHOqICMwobV8=",
            "cpf": "U2FsdGVkX18Ru/DgcKOHvTU1uSvDqotezmtsBKw5kms="
          }, {
            "num_cand": "U2FsdGVkX1/ANl+72ECjHvG1F540ckCj8ok9o0/pCBk=",
            "cpf": "U2FsdGVkX1+6hQ1OZWWtVbtGlX6j4CGMQ0hFaMPeTnU="
          }, {
            "num_cand": "U2FsdGVkX19m/GUqeYX6/7g1c9WUGAt2OB8NaQQO1lY=",
            "cpf": "U2FsdGVkX1/w13Ewl8JMawq3nZdvRlHLdN2Lk7YlypY="
          }, {
            "num_cand": "U2FsdGVkX1+TJzJb+Elf6gN52Co3arns1x9Ax6dN9dA=",
            "cpf": "U2FsdGVkX1/3Vsf/vXfksNGdIoyEYoQ0YrLWfsxVIec="
          }, {
            "num_cand": "U2FsdGVkX1/kic/z/rIxp9B5mhZ8EbwHOWq9pwIX2tI=",
            "cpf": "U2FsdGVkX1+NaxYKhiSWe0pNhT1fuXfxoVV3c0i8UQQ="
          }, {
            "num_cand": "U2FsdGVkX188yBCAi+JBM8rFfBsV86l9Ev27mUozAjI=",
            "cpf": "U2FsdGVkX1/fyEy2F9Evp2WSzg4xnEYoHpyHTf49tA0="
          }, {
            "num_cand": "U2FsdGVkX1+7DunuA8fvGQnz2c+hXeivv+iEX4fDFOs=",
            "cpf": "U2FsdGVkX19HFbZ8rwVL5+hA7RspbbEMbGkbjh7r8wM="
          }, {
            "num_cand": "U2FsdGVkX18Yp6ypF8zXiruEbXygl80jN9XkQLatbeo=",
            "cpf": "U2FsdGVkX1+2iRIJ1dshnTOeodAjDBn+bDa0CdjTShQ="
          }, {
            "num_cand": "U2FsdGVkX1+r3veiqcyDAhupuZXdWxgkQlfDNDGpEdg=",
            "cpf": "U2FsdGVkX1+hOkoUm19blo2H6t82qLE7AWlTKm3S7AQ="
          }, {
            "num_cand": "U2FsdGVkX18OpgqbMiT8paXzfc5WyS3lgSNG4B11xeU=",
            "cpf": "U2FsdGVkX19gNnMyzqEAcEIATxX8ryj9atXak7PJFAE="
          }, {
            "num_cand": "U2FsdGVkX1+41xXiPKnSCeoaktnwPMIDIpYa0ufKfkQ=",
            "cpf": "U2FsdGVkX18XFH3qtl4fOVcBLL+RsM7RwvNX3QBKmOo="
          }, {
            "num_cand": "U2FsdGVkX19UoDLnkDHju3fBvjF8uQq9G8vZ+bw9eKg=",
            "cpf": "U2FsdGVkX1+kDfQR+PZhms+LkAykPlJSy5lOH0XKKKY="
          }, {
            "num_cand": "U2FsdGVkX1/JNSVM+gKgEvwdYpGe37U3V5d5aDfjIEg=",
            "cpf": "U2FsdGVkX1/CjI+3bIKJhBfb6/xWScxuwJ3zxN13/0o="
          }, {
            "num_cand": "U2FsdGVkX18Shd3sCSo7ZxEr9FmphdVlzZQ6SXW2DNw=",
            "cpf": "U2FsdGVkX18daI0z7tpgPUsooN3YAJGO94eWDXaHh20="
          }, {
            "num_cand": "U2FsdGVkX18OXcsBXqZm+Cf/5kTUMb7dKcN1guVkzyw=",
            "cpf": "U2FsdGVkX18Cybfa9zdWvWGhdGNq1t7jDFpF98xJZlM="
          }, {
            "num_cand": "U2FsdGVkX18cG2AV/4IRtdljHQP5AUoiEOLMuP41gFQ=",
            "cpf": "U2FsdGVkX19Pfsh9NDlhMasxajp1+KI6IVrf+tNBm7I="
          }, {
            "num_cand": "U2FsdGVkX18j5JwvLAvCXPyXF0Rqocrc68fRdHxP/WI=",
            "cpf": "U2FsdGVkX1/Hr8Z8btStwSdDqQucAeAwEwt/ZwzN9j8="
          }, {
            "num_cand": "U2FsdGVkX1+oJjxjzTj4YgJv6cYhCMzjcB1X9MxY4Kg=",
            "cpf": "U2FsdGVkX19PL0ZtmPiUD8w3xIdJhSoHswXYAevT9BE="
          }, {
            "num_cand": "U2FsdGVkX19BRxB11+Tp3P4XgcSNS2X/xRXAIl4kbmc=",
            "cpf": "U2FsdGVkX1+1wK8zIzcwh4KE/Inn7xW7v1uT4xOq3Xs="
          }, {
            "num_cand": "U2FsdGVkX1/5IwRApRERvgZp8ZkWssQAIeWrFrBVWu8=",
            "cpf": "U2FsdGVkX197R74O6F0q8aIkO4DLBFRtxcz3tvGbXh0="
          }, {
            "num_cand": "U2FsdGVkX18F5flidmc0fBwMe/BkEp2GQjNAan3LVAk=",
            "cpf": "U2FsdGVkX19c3SDu1/WruZcoZ8Rkc/LKyvwXLQr4Kag="
          }, {
            "num_cand": "U2FsdGVkX1+MqEtyw7WUdOsja5OiZu++w2TnRlaAdMM=",
            "cpf": "U2FsdGVkX19oimlqt2QkfAMJ+6hX3JUCLQmE/l8QfO8="
          }, {
            "num_cand": "U2FsdGVkX19xghd9cDbA4KoIZNyjdiOLu26lRCCeOE8=",
            "cpf": "U2FsdGVkX1+boDbKS7XMgAm7HQXmiChOFIBHZIgWNbk="
          }, {
            "num_cand": "U2FsdGVkX1/wT1QSCOKjmFckvlWmHiOrsbUw+yiiTUo=",
            "cpf": "U2FsdGVkX18ncQisk71OaDjtX+ks8GODhuZXVbMVGvI="
          }, {
            "num_cand": "U2FsdGVkX19SUkhGyBwq0Sm14COzWrInZjsNxBxKDFU=",
            "cpf": "U2FsdGVkX1/um4A5T+EbLszM3ia8kdCV4bCTchrAMW4="
          }, {
            "num_cand": "U2FsdGVkX1+EoiPP3tHNxhWsdoNnD3FBUDKKtllyrxE=",
            "cpf": "U2FsdGVkX19TEEUIrGOw713n91YGe1vR+laqN8r7Gm8="
          }, {
            "num_cand": "U2FsdGVkX1/dSAZkTb2YCiiVc3Hx+hDDXqBod6EoUWw=",
            "cpf": "U2FsdGVkX1+hvAQlZ7RkcTY5rDgPW0aW6TA+7ogdBzc="
          }, {
            "num_cand": "U2FsdGVkX18OLcmsDXgMPwj685vJFo8SPdAtwEMG5GE=",
            "cpf": "U2FsdGVkX1+DP/TrOj7gMWrsaBz6xTZhRo3BDWteO9s="
          }, {
            "num_cand": "U2FsdGVkX18o+Yt8phtLVJHO7SQIqlSFoGJ+bfHEwmk=",
            "cpf": "U2FsdGVkX19mt+79imuMkiMj0+GcxZjiTte+/9LW6tI="
          }, {
            "num_cand": "U2FsdGVkX18o2L+y+of6/Qm7Mo5D+Npr9GZfQhBSxw0=",
            "cpf": "U2FsdGVkX1+mmCfcZqzxUh0txrmt3g0SA5uUKwjmiSs="
          }, {
            "num_cand": "U2FsdGVkX1+2kjSkGUPHwFVyrkyOsVPF6e3tGXHAYig=",
            "cpf": "U2FsdGVkX1/HtvsgrHJOOqc2adB6NupNBJ6LUlRsB/g="
          }, {
            "num_cand": "U2FsdGVkX19GmGe0Vij9hM0mIP6D+ZN2FJcG3aH7aHI=",
            "cpf": "U2FsdGVkX19rrdGe0lEGPjx3ML9aANQ3knrxOh1FNBU="
          }, {
            "num_cand": "U2FsdGVkX18ZuoeFkl7ZVdegnjuQ/g0PWUP8KLSJ2JA=",
            "cpf": "U2FsdGVkX1+DuEVZbWmw+VgfVWgsrm0T9+hACzguG0U="
          }, {
            "num_cand": "U2FsdGVkX18RKmRDJwi3MW5NPwveZf12+rHuWUdn61I=",
            "cpf": "U2FsdGVkX18anGAQMb1NLRSpEGdCTa5lSROssvQGAEA="
          }, {
            "num_cand": "U2FsdGVkX19qi127rBzr301NNLeEjxUn2A7aROAuoT4=",
            "cpf": "U2FsdGVkX1/FVMBedXxz0bszc+thJ2MjcP5Hud91JG4="
          }, {
            "num_cand": "U2FsdGVkX1/qOYA6f48dbMbmc6BBlcX4aK76Smz9l3Q=",
            "cpf": "U2FsdGVkX1/bKR71zIDOtNgCcY4rZMpKOGiV0Y42ur0="
          }, {
            "num_cand": "U2FsdGVkX18syO0QjozlCk/kKTCB6gx7pAPidqgRc3M=",
            "cpf": "U2FsdGVkX1/x5QQ7pS8mwPnuggtOQe4J6/9V6kE3vtc="
          }, {
            "num_cand": "U2FsdGVkX19B1vT+syRxKFf6KdcOAh3rQnKY5bRg3D0=",
            "cpf": "U2FsdGVkX19YXnQ46emDSuX5PdaG+DbWTlObMEK3t7o="
          }, {
            "num_cand": "U2FsdGVkX1/pbmSjMpUj4PuOgN9m1gWCZS6ZULvISho=",
            "cpf": "U2FsdGVkX1+TY9JQq2Mc5uMIZlDOFGqUQutxH14sfJg="
          }, {
            "num_cand": "U2FsdGVkX18IHo2FB7Gz7KjNZBNkdyKt2Iht0hnBxWA=",
            "cpf": "U2FsdGVkX18zfSa71MRh/k6uAcbeoPzfoahF8KPY86M="
          }, {
            "num_cand": "U2FsdGVkX19nUDyLTSmfssxhv7UBAs2VMcSpEZb/08M=",
            "cpf": "U2FsdGVkX1/FC/sMGy30kcMiuBXfaVpELQGDevqUpMM="
          }, {
            "num_cand": "U2FsdGVkX19JEmGmtv6YBBSkMa8TR0pW4Soyo25BcjM=",
            "cpf": "U2FsdGVkX1/Am1Hpv9lczFlUl8PL1CPLC2/R0LEbO8Q="
          }, {
            "num_cand": "U2FsdGVkX19WiDkyWpu0CoVsfYgHxVtVr8uQE+e/si4=",
            "cpf": "U2FsdGVkX1+fuDiR3YVPQKkhotceJOQlSIp41FUEmiw="
          }, {
            "num_cand": "U2FsdGVkX1+37SUkMD+ZPnMQWkxl/UT0CSZTZX2uyLk=",
            "cpf": "U2FsdGVkX1/BUCawmlojM7Pvnwi+/UUq/0ZbhOGSAIk="
          }, {
            "num_cand": "U2FsdGVkX1/rV5Vk5uXrr3HHoaY+/dchYi716ay+Op8=",
            "cpf": "U2FsdGVkX1/UHKf4OFh4uqGriq70KYfYWxyi5gW+y+A="
          }, {
            "num_cand": "U2FsdGVkX18Nr8TqnobPLZbNXkdkyHrPD656zruFrzk=",
            "cpf": "U2FsdGVkX18Mjs5QT4m8p4O5rgK0CR2LJWE3nm76rK4="
          }, {
            "num_cand": "U2FsdGVkX1+ILlF5Pt923q5GcIAw8SDOZ3NxhG0i4b0=",
            "cpf": "U2FsdGVkX1/AEtL/1uhV16Ldf0sA56B77jyJwBCl1U0="
          }, {
            "num_cand": "U2FsdGVkX1/tocSB6TR0UHJmXXvY+/QRsu3nlprwBnQ=",
            "cpf": "U2FsdGVkX1/QD2OFT2u6UYt+tpIRcHrlCSzC5K7Pmc8="
          }, {
            "num_cand": "U2FsdGVkX1+0ZAKleAowDAuGUubfJK9HaN4RBcb9eoA=",
            "cpf": "U2FsdGVkX1+U27DupyuZEjpectsl4kp7Iw2LjQx6KcM="
          }, {
            "num_cand": "U2FsdGVkX1+OqsPB06GVPyQXvvTomjkfUSryUGak9rU=",
            "cpf": "U2FsdGVkX1+FE6Q9PhYHDvOHkLIrUIJXX5ccsOIcSA4="
          }, {
            "num_cand": "U2FsdGVkX1/BzKfrYbqpKLX6qvv8178QKeDVXc03eJg=",
            "cpf": "U2FsdGVkX1+NbtzmTIf2jJverkhThmgt4csJtOmUbkc="
          }, {
            "num_cand": "U2FsdGVkX1/9wonM8VbaJM51TqxkP0XADOrIVHiV1zg=",
            "cpf": "U2FsdGVkX182N0m87tYzH1GAJ3J5NO6ECh6RUUFE7gs="
          }, {
            "num_cand": "U2FsdGVkX1+G3/qdRfH6IN9DwDiL1m9FcW4u89tIzPI=",
            "cpf": "U2FsdGVkX18pf3xz9xdRFLOv2TvxGec8Hi6drDbRvIY="
          }, {
            "num_cand": "U2FsdGVkX1/Gk2yrCLm+zb2MxR1PQjkE7lPAaNKzo3Y=",
            "cpf": "U2FsdGVkX1/BFquLVtOtD4VfUdtQs19/YTs3sw4kYSY="
          }, {
            "num_cand": "U2FsdGVkX19PI241uW+RSb1IebagY3vNb9kiU9FPC9Q=",
            "cpf": "U2FsdGVkX1+tY3m3LIl8OsOgB7OUkDr4wv1R1XX8eLI="
          }, {
            "num_cand": "U2FsdGVkX1/RSs2GQau7IaiM6KeOZImR2hOIHfBKL28=",
            "cpf": "U2FsdGVkX1/q5n1JPNedNpRRfOo+rANMVBWhuCuUIXk="
          }, {
            "num_cand": "U2FsdGVkX1+NI34+XxWpQeFDCP8iw83zPlSYubbaoOM=",
            "cpf": "U2FsdGVkX18UYmteXU25aGslH29CB6aBPKmHputq/2Q="
          }, {
            "num_cand": "U2FsdGVkX18wTT2MLhhejf7czOkTqn0LR99Brwrkob0=",
            "cpf": "U2FsdGVkX1+RE9iPALRKvZJhcIFjqkM+4xa/imvWCMo="
          }, {
            "num_cand": "U2FsdGVkX1+W8HzCz9o0pgNRD7beznsOdare6Vfag7s=",
            "cpf": "U2FsdGVkX1/rz+X9DNXLOjfXUbDSDmXd+FRSOWc5EzE="
          }, {
            "num_cand": "U2FsdGVkX18OI1XJHMbs6D9eis85MPhwTiHAXVkVzfE=",
            "cpf": "U2FsdGVkX18f/sBAlKIRtAhgmc3AX8emh44D8XpbjP4="
          }, {
            "num_cand": "U2FsdGVkX18xS0QclVSVG0GOS1ieVWZrgucKyWKWeYo=",
            "cpf": "U2FsdGVkX19mQcUtIJtQFnKFrlFWrq1XGhp3+TBUZMQ="
          }, {
            "num_cand": "U2FsdGVkX19EHS+p88i5B7R8rUFf78Yncd3eFDnOxPg=",
            "cpf": "U2FsdGVkX1+oopa/jQ4SkuqtXS24nQozy4PyHIRkkjA="
          }, {
            "num_cand": "U2FsdGVkX18o3DtHK0NG2bvq6y3bs+FIeFG7SQDeBzY=",
            "cpf": "U2FsdGVkX18jSOtZDHD+Mg/LT6TxD+44jJBimx0SCCY="
          }, {
            "num_cand": "U2FsdGVkX18j2fbvcoDH7pQgdW1ODsOdO8bvHlUxWHk=",
            "cpf": "U2FsdGVkX1+Byu04qBbG+na8dCm3QELhVanUdB2wEiU="
          }, {
            "num_cand": "U2FsdGVkX19/wlmbZx7v+zDReniXvOeXMaAvqQhus70=",
            "cpf": "U2FsdGVkX1/TM23cZkOmLa5GBGwSRYKcj4qtvxubClc="
          }, {
            "num_cand": "U2FsdGVkX196lnCWuDUVDavj4hWUEwfyUNxuWOeIcXk=",
            "cpf": "U2FsdGVkX19Ker+9OgU/wJoib2kQIf/qThDlvTmdvFo="
          }, {
            "num_cand": "U2FsdGVkX18pNWMfo4jE78ijgZBhDnxqrvtJjhdQcKs=",
            "cpf": "U2FsdGVkX1+vQXx5JnCeiFvW2d8fQy8UAJleXZaunTQ="
          }, {
            "num_cand": "U2FsdGVkX19VWuMv/DzLeYdCu0bokPtWtOQ4k72qUOM=",
            "cpf": "U2FsdGVkX1+mdeqTT12IUJbCsQoLRY5PxVhzVmcigbM="
          }, {
            "num_cand": "U2FsdGVkX1+ySbcyE/4Gc8cxTjfKAfnI9ctJnqKX+tM=",
            "cpf": "U2FsdGVkX1+HWefFxQpx8B+P5dqEfEhNwychqloA+dQ="
          }, {
            "num_cand": "U2FsdGVkX18J88gNFw8QOsNMM8KfzKaNV6f6nMVUMCk=",
            "cpf": "U2FsdGVkX18sBtW1XpCpgEfly3qnsABw8cwt3hixYIk="
          }, {
            "num_cand": "U2FsdGVkX19QebnxqZGjmyp1TfLzlyNbdzop4EzBBwI=",
            "cpf": "U2FsdGVkX18Le6iohP+Wbiyf2YaPOLCGu5P7U2XYplM="
          }, {
            "num_cand": "U2FsdGVkX1/AL1sYNdJzgYVToXog40GdxYPBmP+3GGk=",
            "cpf": "U2FsdGVkX19+MTWwsg1+9ASaaCaczKRk6DKuXq0O3DY="
          }, {
            "num_cand": "U2FsdGVkX1/MQc9Yg3FnVMKanpjWPo7RbvgCy6JOPe4=",
            "cpf": "U2FsdGVkX19lpCB3aDmpxtGhSxuZ+m4+0RpbROchjMM="
          }, {
            "num_cand": "U2FsdGVkX1/rrIhnd0iRcY/+migSAvkOCLx5mgAds9o=",
            "cpf": "U2FsdGVkX19MeIH6oD3nsq+Gqvsu7EPOKdu9hDGbPlk="
          }, {
            "num_cand": "U2FsdGVkX1/eKwElwgk30+kGq1Qfjni5CcNX17xsx0Y=",
            "cpf": "U2FsdGVkX18GEfV4SCu6Equa+gIK+/jg7xdGTeBDBp4="
          }, {
            "num_cand": "U2FsdGVkX1/VsQlLqi3xumAvNv/JZQnGaDXb7c+e5F0=",
            "cpf": "U2FsdGVkX19oEQHnoXnoe0pLEKRnohbr4zJfj5KgVSc="
          }, {
            "num_cand": "U2FsdGVkX19MzuKSbHLzAJwptCBdt06h9wJLdBizovk=",
            "cpf": "U2FsdGVkX19+rYTIcHY9QapTl6zvmRLuPDgKSytNqsg="
          }, {
            "num_cand": "U2FsdGVkX19glg+ccPtUL/MYH24+gkyNoQOqORmYapE=",
            "cpf": "U2FsdGVkX1/ABQTE2bFrgDOXbTqPJDOVuEOVdRefbAg="
          }, {
            "num_cand": "U2FsdGVkX1/wm0VutWAqz/SZQ2aI5V8QJuTb3FyoA8Q=",
            "cpf": "U2FsdGVkX1/XdE7cngANQ9pfNCybCUQktYTgmzgHDIU="
          }, {
            "num_cand": "U2FsdGVkX18g5br5TA1wTECM8tPhOQ38mpe/diKNTGo=",
            "cpf": "U2FsdGVkX19hpQxeExH5GBXN64Rk8fMDKZ0b8WZYJF8="
          }, {
            "num_cand": "U2FsdGVkX1+1+i/rSn/fz8ox63DYIHxCL8hi1t4Isu0=",
            "cpf": "U2FsdGVkX18oDAqcIjEhla93cdLDev9wQF41mN3OYLk="
          }, {
            "num_cand": "U2FsdGVkX18xQrpPQz9d0dj/ir9IpNB9CITqL87esz0=",
            "cpf": "U2FsdGVkX1/ecvdYuaMY5O6IWG/4hnWUknBauUvbvhE="
          }, {
            "num_cand": "U2FsdGVkX19TbKJyL+3zdABOxH8UaAwlwPatSx2wC3Q=",
            "cpf": "U2FsdGVkX19ManVmd9h+lohQ+CZwTE1xQrwlm2fRBsU="
          }, {
            "num_cand": "U2FsdGVkX19axdNYQ1Wa1pFRlGaT0vPYSUBn9T/O1JQ=",
            "cpf": "U2FsdGVkX1+nQH25BCwFVMKcNns7xf1ykofKmSTWpHQ="
          }, {
            "num_cand": "U2FsdGVkX18qETiNMIifOGkKE+iieY4J1jigGUMgk7U=",
            "cpf": "U2FsdGVkX19AlHt/YBFYg61J4jRoXw1B3LcB8/5oQlc="
          }, {
            "num_cand": "U2FsdGVkX1/HpAzW+cbENko1GaRtFCT3VLpKyY65jI0=",
            "cpf": "U2FsdGVkX1/2PAaCa78T4pXOTVGRWH0Fs3ggskYsCqs="
          }, {
            "num_cand": "U2FsdGVkX19NqPpwauHVXt7oqLuFgAkZ8jbWmR9BNQI=",
            "cpf": "U2FsdGVkX1/tk3YTjd4A4cc2mCoqRmCCUWObX66WqtQ="
          }, {
            "num_cand": "U2FsdGVkX1+LiY0cUXJN3fG6cipcYRPItln4SrEAZoA=",
            "cpf": "U2FsdGVkX1/U3WElTQSGT/nf2TSUYlWtkYAO2kwmKlA="
          }, {
            "num_cand": "U2FsdGVkX19febGQ/UOGQq78k7b6HHU8j5XdsDHFsF8=",
            "cpf": "U2FsdGVkX199pf4K9ddSgdDdPzT3sGciFik7a8P5bjI="
          }, {
            "num_cand": "U2FsdGVkX19YMA5dy9TVogcwmx/pPzbYLhpgNjEfFv0=",
            "cpf": "U2FsdGVkX19k6PaqIBfJNUYAiskNNxWA9dMFp5MKL3E="
          }, {
            "num_cand": "U2FsdGVkX195seP4KB8d6asO99CfPsQakvHmBm9owuI=",
            "cpf": "U2FsdGVkX1+5ZzHUyq1x71Vrmy79RlIm+aye80Ip7y4="
          }, {
            "num_cand": "U2FsdGVkX1+gu0uSjqGKNth113IeJhquYRKka5WiAYs=",
            "cpf": "U2FsdGVkX18fX5UbiYg7c5u3EveMBV9PsyIBBMmcqfk="
          }, {
            "num_cand": "U2FsdGVkX19TtPEa7ewjFU53oz9o/yRAvkIEhzKaWNk=",
            "cpf": "U2FsdGVkX1/HLPto9sGVawgv7qd2hGkHNFSF3CplfAI="
          }, {
            "num_cand": "U2FsdGVkX1+bV9Byec3Thyw+7OqHytSpjUbBhi+Iq+k=",
            "cpf": "U2FsdGVkX19F3jdGEJDgdje5fJkXPoziHx/x5fhfvbY="
          }, {
            "num_cand": "U2FsdGVkX184haAAOTgj8xPx/XH+1HeqYsIoRocIoBY=",
            "cpf": "U2FsdGVkX19lJ1j8vBTHC5QjkNL3m9x8bFNZIOPUwqk="
          }, {
            "num_cand": "U2FsdGVkX19B17MKfGOSnRZqSRg+U1MNVx8MsKVP8CQ=",
            "cpf": "U2FsdGVkX18Mao+g7/KtdZ4DzRxW+jFphsruxsTGQFM="
          }, {
            "num_cand": "U2FsdGVkX19gTOGxDQKbIzvctbmT8TWIeL0+iyl4wo8=",
            "cpf": "U2FsdGVkX19xmBmaZCW5uV6eaxXv2M3BFj92DsPJ0/U="
          }, {
            "num_cand": "U2FsdGVkX18CVpP587fi9ERVA2/YuHSs1mL7fDrkfII=",
            "cpf": "U2FsdGVkX1/2lAhUTe55wpJlQqHC/aApMZiOt0vJ6tU="
          }, {
            "num_cand": "U2FsdGVkX1/EhTBa70ZZd8pSuqu9t0+RAuDOKRuyvjE=",
            "cpf": "U2FsdGVkX19UuC+/QqcGFYMMKOhl+cFXPazqBnxcZSU="
          }, {
            "num_cand": "U2FsdGVkX1+RmLMyxCzo1VGVGhbUvD3q0vsDWZQpcX0=",
            "cpf": "U2FsdGVkX1/mUBR47dSWM7dkBRVlM8hESgd9Vwyib8w="
          }, {
            "num_cand": "U2FsdGVkX1+MKL1ZkzsrAHoGb1EmZajM9NTGzfS3ukQ=",
            "cpf": "U2FsdGVkX19BKfHb6l9p8nqgF+OYFie8EoDkp5pFFLE="
          }, {
            "num_cand": "U2FsdGVkX19RNWqdWGquJWl5PIQ96mItLYQGb16q7ug=",
            "cpf": "U2FsdGVkX18AvDa6i9HP15/MQqIRWMlj7RwsSkFqGV8="
          }, {
            "num_cand": "U2FsdGVkX1+Gq7Nrf7+qd4JL1teHOD0tXacqAeYydMI=",
            "cpf": "U2FsdGVkX1+n+rNMEgjjlnQhAUNmGfs9+iOHK3/DtJc="
          }, {
            "num_cand": "U2FsdGVkX18wqYF8IyUWwbJzi5DnDIVTpslQpU7ahKQ=",
            "cpf": "U2FsdGVkX1/P2IAOpd3Y0mbdS+JZlXgqN1khXE00/58="
          }, {
            "num_cand": "U2FsdGVkX19yHDVugz8lZx5Corcaosl8HjaW0+2FXlk=",
            "cpf": "U2FsdGVkX18bGyiU3UMFiGoxm7GgjhviILt7imQ+Io4="
          }, {
            "num_cand": "U2FsdGVkX1/+qSu4qZja+7YLJ7+zJLW7tP04tNCtpy0=",
            "cpf": "U2FsdGVkX1+uIxwqUYWfwpnSh7b0aOvVnM1ovuYBU+s="
          }, {
            "num_cand": "U2FsdGVkX19Uvyo1soltboVpPVIyksePXtzHgu/F6Pg=",
            "cpf": "U2FsdGVkX1/n4d5ucJDD/L3zttt1hQOY1NY+dT0+GGg="
          }, {
            "num_cand": "U2FsdGVkX1/3sb5A4gltIIoMqEq8CrNe7BE0gxVQzcU=",
            "cpf": "U2FsdGVkX1/TTIPTlp9zJSQf0rFp2NL36cgh1Ejv+hU="
          }, {
            "num_cand": "U2FsdGVkX19gOTZltHZLHIdBzi1JTKVK9p7/rpwKnXE=",
            "cpf": "U2FsdGVkX18vIbGtAKkuh0TBnQ5FLftdUbPs7PHxyDE="
          }, {
            "num_cand": "U2FsdGVkX1+X3Wki9aS2TEiZe5TG4BqstnUOkzjFEA0=",
            "cpf": "U2FsdGVkX1/v6kiEDjkQeYZ2iAt/lTlnG+Cs4K1O7x0="
          }, {
            "num_cand": "U2FsdGVkX196FXZIWPBLY6NOa4yd+cupYUGPvUQmzD8=",
            "cpf": "U2FsdGVkX19ikXQiL3w5eNV8JZE74VLSEFyu79NE1UQ="
          }, {
            "num_cand": "U2FsdGVkX18lpY7aLpcLbI3s/2b5fHdNgg8gwrGP4bw=",
            "cpf": "U2FsdGVkX1/ra6YRyc+1CtkZKl6j9/HzWG6DfXpNVKI="
          }, {
            "num_cand": "U2FsdGVkX1/9SPQUmF5rgT9mc/8WqIQnPxulHx6hSd4=",
            "cpf": "U2FsdGVkX18W++wRGZtRc8qyuunZvllXiQOb4hr1vmw="
          }, {
            "num_cand": "U2FsdGVkX18h5svpfgy547IINj8MfOdJ1hnnNN2iP60=",
            "cpf": "U2FsdGVkX19CfgvmF2Jaa5ENsOhDJmWAqlUHvpSb580="
          }, {
            "num_cand": "U2FsdGVkX19JISWpdkH4WnyrKiItiU2sRIB3ztX5+EU=",
            "cpf": "U2FsdGVkX18XuVXVL6XfHtA882W268ZkQIxrCL1r9Xk="
          }, {
            "num_cand": "U2FsdGVkX18hapDPoua637n7N5jG79en97GwuEz/Pww=",
            "cpf": "U2FsdGVkX18cr2TQ+2FsTpXMQTODYsfncryUuVAHYuU="
          }, {
            "num_cand": "U2FsdGVkX19HabB/5VC4BxgmBT8sYZooKZT5ZvVqBlU=",
            "cpf": "U2FsdGVkX1+mY2QwRFQUiZceAgm5Csn+ztAOrjgd8Nk="
          }, {
            "num_cand": "U2FsdGVkX1/h5kKropqmB8qJKatvuOeB2+CtmFsRCD0=",
            "cpf": "U2FsdGVkX1/gGuIAp5pZYBJrjaWzYusZ6q4EwI6Gpjs="
          }, {
            "num_cand": "U2FsdGVkX19wcFZtFM7f/9IRq6+QcVvPkrHwsZt23OQ=",
            "cpf": "U2FsdGVkX1+R8pq1whSGzX/Ev0MMjofXW1xNEmesw5s="
          }, {
            "num_cand": "U2FsdGVkX18rwp2gRT5KEXnGz3tsLTltFxpHHYdvJoo=",
            "cpf": "U2FsdGVkX18EYhZD2r50irmeVFNPsiXFLEXR+W2viGY="
          }, {
            "num_cand": "U2FsdGVkX1/S0Pbzf2ZdSnOhdSOfqclzjgwDO12s45k=",
            "cpf": "U2FsdGVkX19MitxEtVyXeCepTVI16uGF9tf807W0LyU="
          }, {
            "num_cand": "U2FsdGVkX1/mJBTtdh5Z4xiLtgpb7qOEttzs6I/YcXc=",
            "cpf": "U2FsdGVkX187zre6tI17jN6clFVDmj0FjWS4jfsCJIM="
          }, {
            "num_cand": "U2FsdGVkX186dWK3e+xWlUgnaEO1jJyL6h6UXQGX35o=",
            "cpf": "U2FsdGVkX19WkUtGMq5zJK1a8GYSRwlOrrj6lkQVZmo="
          }, {
            "num_cand": "U2FsdGVkX19c6RxpuEaWHOVno/bET2k/FV3sGCUVz4c=",
            "cpf": "U2FsdGVkX1/a5bEepA2HL78U4jBmpoxDofCntmsyUPA="
          }, {
            "num_cand": "U2FsdGVkX1+z/pD8s4nqx2mYmhclYdYJtLbTZGVO8K8=",
            "cpf": "U2FsdGVkX1/RxnTiBekNTmyoejkFSlzrCuaGvIjYFBY="
          }, {
            "num_cand": "U2FsdGVkX1/4qLDi58hTph0yLeb+zn4yl5s2K2Rt19A=",
            "cpf": "U2FsdGVkX18hvPcS00sc11gDGUhNlYa4G8QME6zFHYY="
          }, {
            "num_cand": "U2FsdGVkX18mZGA+kydC1/Q6fRZUL+XaYIMRJ9giXYE=",
            "cpf": "U2FsdGVkX18IoKjMRqZ5InDFRgFIjijrlwKFAxCymuQ="
          }, {
            "num_cand": "U2FsdGVkX188LGCuGlfxQBopyVb+kY83TcCt+z+CdGc=",
            "cpf": "U2FsdGVkX1/jU+nYR4dzv0BgtVuSrH5yt+6xvGPiz+w="
          }, {
            "num_cand": "U2FsdGVkX18hp+rntErKrvHcZK1fvcHsk+OqzXNj7k8=",
            "cpf": "U2FsdGVkX1/KNs3ctK7h5BH3eExcNKdDkiNW+2jn4Bs="
          }, {
            "num_cand": "U2FsdGVkX18VMsgK/yGujlannMeARu0B3ca5ByAzzMo=",
            "cpf": "U2FsdGVkX1+dktt2MBQyJqxWi4Yvsrh03WFvsFkRCXk="
          }, {
            "num_cand": "U2FsdGVkX18WvjYTs+owgkya52zkbswV2/WIsL7Cda4=",
            "cpf": "U2FsdGVkX1+GT7/oTtfL54h4ZQYsBFqMNwOFxuTX5cY="
          }, {
            "num_cand": "U2FsdGVkX184Xvq5hqogFVe2eGmTcQSVVDJcxqHsGYw=",
            "cpf": "U2FsdGVkX1/jDbPBN3AWfo9fajYQNI7DMUJRAzfB2ow="
          }, {
            "num_cand": "U2FsdGVkX19EdwRB7wbhVXq4kdzx5iTx2kPWInhxjFM=",
            "cpf": "U2FsdGVkX1/rABAXfpK42SjpCwOdtGHV8XGPVu8ZI9w="
          }, {
            "num_cand": "U2FsdGVkX1+mr2xp0rJSVpM7lkayAgST7XwKGbk5+b8=",
            "cpf": "U2FsdGVkX18qXRbdsK9ovh0xq0pO02FpNk7IDA6RKlI="
          }, {
            "num_cand": "U2FsdGVkX18LI8R/Ose/dUOovB8EJ01LBcvbpw28RtY=",
            "cpf": "U2FsdGVkX18vh63kELYBy7V0u4K8J2yWnziT9ARwLBc="
          }, {
            "num_cand": "U2FsdGVkX1+5/PKtOLlknI3yP8sBwxzbzgy8pymDOWk=",
            "cpf": "U2FsdGVkX18I15xDp+m1+3uy+gf2p9bcjFa+GGijJdQ="
          }, {
            "num_cand": "U2FsdGVkX18qsWsq+liiSBKmUfhqttYSIsF8xw35vFw=",
            "cpf": "U2FsdGVkX18OZKuDC8G3fgbW6rOwoII4ilO53maDSRc="
          }, {
            "num_cand": "U2FsdGVkX1+Z3d61Ahismq2FQ64MA+HGt6TLNtZ6pEk=",
            "cpf": "U2FsdGVkX1/0QCiLPgXXPLD+dNGAntzW2Rgdfar52Fg="
          }, {
            "num_cand": "U2FsdGVkX189rlr8om9nC6DotuazIPq2X6Pw5/YFkOk=",
            "cpf": "U2FsdGVkX19EBWCBVuOQpO/DJh6J0U/Tja7uqzJuZLs="
          }, {
            "num_cand": "U2FsdGVkX1/3e3aCD5zDcjDT3zozpK9bFPMoN1KTATE=",
            "cpf": "U2FsdGVkX1/9JlO7H8xiOUyOCVL8wvXg+xOTRfWMwIk="
          }, {
            "num_cand": "U2FsdGVkX1+tmbe2U1YiltcrOxaT8KYmtVWijuqMSoM=",
            "cpf": "U2FsdGVkX19gGjMg75+sRRAB3g60aF7dwICg2cUOruA="
          }, {
            "num_cand": "U2FsdGVkX1/M7OoyBKXAXnwlygrc9F5yCwcw57O9hms=",
            "cpf": "U2FsdGVkX1/fC0SO4Enl5kPniZ/wGxkuKadVeSCiHQo="
          }, {
            "num_cand": "U2FsdGVkX19WlY/V1wf8ydAZm/I7MIEucFjIE41FOQU=",
            "cpf": "U2FsdGVkX1+bpP2eImVQuS/svPLSaDjQXqPebeho2Wg="
          }, {
            "num_cand": "U2FsdGVkX19USRngSRgO3Bik66qGm3+W5h1dSD6QPD8=",
            "cpf": "U2FsdGVkX18GFDddjokBLz5So2ede/cHQoHGHJQIAjM="
          }, {
            "num_cand": "U2FsdGVkX1/n5RM6Pix1lE/lG1Knl7ldK0SiqjrYvX8=",
            "cpf": "U2FsdGVkX1+aH0iwfYYR/5joCBXI5Uk6GcEk2lJqCTc="
          }, {
            "num_cand": "U2FsdGVkX1+0bPcNUvP7h2PuQL83yeFpTF0IaHn9loY=",
            "cpf": "U2FsdGVkX1+EA5wpdKOvQccKKFKbkcLkL0Ld+fxCMgI="
          }, {
            "num_cand": "U2FsdGVkX19pMSjxC197w8Wr+Oq3xD/jzJrRQy7b/PA=",
            "cpf": "U2FsdGVkX19t+wbqEFRx5Bd2A01rbIdb/jdhg34D26s="
          }, {
            "num_cand": "U2FsdGVkX194gpgwyPJ5NLSHRnZa70f//II166Gy/PI=",
            "cpf": "U2FsdGVkX19CpHqhwBi9o927LnUR15Tl9CH2lHCD7vU="
          }, {
            "num_cand": "U2FsdGVkX1+dRfhZTTBDZJXBblJTtM9qmwBFbnZwFDQ=",
            "cpf": "U2FsdGVkX19ykiSOJVE30VbzhTeUE30uYajRJM5ieQA="
          }, {
            "num_cand": "U2FsdGVkX19Ra6S9Sz0VLhe3aKkz5qtMy/F9DN7Zaz0=",
            "cpf": "U2FsdGVkX1/nKClQ4yiiiXy6M9ITDYt2mNpIAsbaarI="
          }, {
            "num_cand": "U2FsdGVkX184oL50rCOvrnmTHwYr8cpJdkqd1ERMeqM=",
            "cpf": "U2FsdGVkX194tR4hptRl7WdfPuNgKwGZ4qoEDV8ZNow="
          }, {
            "num_cand": "U2FsdGVkX19vEk0QGQxVZKGEpIDdSSmCJVOPVUToabs=",
            "cpf": "U2FsdGVkX18qDqMc/dlw8j5MZa+xmztSZQyESObLK3Y="
          }, {
            "num_cand": "U2FsdGVkX1+R+/2EtMLO4ytjZ//ZPwwmlqS0DQNHoEA=",
            "cpf": "U2FsdGVkX19OFzg9QEtYH2SQv/3MpYj1vnsD2Bo7X+E="
          }, {
            "num_cand": "U2FsdGVkX18uswI/zNIeGeFlPV7w0ppAmwYxszTq7RY=",
            "cpf": "U2FsdGVkX1+vOSS1jnnHM3nXexaybfaZ7br201mkSAM="
          }, {
            "num_cand": "U2FsdGVkX1/szivBoGGYX7JI2z4u40d9L9RAwHm4fFg=",
            "cpf": "U2FsdGVkX19cmu9WuDdroP8HcHm+3knKepN2Zh7ggbk="
          }, {
            "num_cand": "U2FsdGVkX19A5YMHUYHEkeHLMJw6TtXkCiROF2ctXqM=",
            "cpf": "U2FsdGVkX1/hRpY2H8Bt2cC5/HwmraPWb8yCjIegyMI="
          }, {
            "num_cand": "U2FsdGVkX199sSvgVMPFJe1JT7HjRjJ8QxlE1lGoc20=",
            "cpf": "U2FsdGVkX1+KU257W1pRg2XsJBLTAfLpVUFfsffVMtk="
          }, {
            "num_cand": "U2FsdGVkX18ZGfXAQoDaUb+AlT+gEeAouKcZuPkRSLw=",
            "cpf": "U2FsdGVkX19rF2UMEUL4r/ruixQ1u42B3IiBduRYqLQ="
          }, {
            "num_cand": "U2FsdGVkX1+W+pc54x3HQrf/VLKTzZFBHzAH2qRsFE0=",
            "cpf": "U2FsdGVkX1/B7ia1pcKg/HyiHGep9Vyetl6LjScf2tE="
          }, {
            "num_cand": "U2FsdGVkX1/HM1NT/C0pN3vjvD7Ark7EoAKrCg2OEd8=",
            "cpf": "U2FsdGVkX1++wGaR9uibuMzR1O5Egd859NgPAerjBTA="
          }, {
            "num_cand": "U2FsdGVkX1+ElKU2PK7TvXrCDmIpob+rlQ9+RYNXTRM=",
            "cpf": "U2FsdGVkX1/zxPFl2REjfyqsEgtLP6NMFedEmF8P9Ng="
          }, {
            "num_cand": "U2FsdGVkX18oCLpykj4uSJRV2I5vSEv+b7Lvtgyw+44=",
            "cpf": "U2FsdGVkX1/UVnQ5UtfRXuwjHlRw6KAAxk0/R9YE5dE="
          }, {
            "num_cand": "U2FsdGVkX18SMR73tJ3HaJgZ922xqUcrHq1tzeNWyOQ=",
            "cpf": "U2FsdGVkX18XM5KBD4EwTT3/5mK70osEmvL9InrHoM8="
          }, {
            "num_cand": "U2FsdGVkX1/IZZuRE85qkBuKMrqlbQJgilhVA2ukZ3w=",
            "cpf": "U2FsdGVkX1+7L2Tma4WrcbrCFMemPatzpIh64BOXpkA="
          }, {
            "num_cand": "U2FsdGVkX1+j83ZR0diy+anegtWf85DeNq3ArBuIT8Q=",
            "cpf": "U2FsdGVkX19vedf5xzWEhtgdsaftCC1CJtDpz9pqPds="
          }, {
            "num_cand": "U2FsdGVkX19RHhxrDYGClmqeXIjB0DHpAo/jBEGFG9c=",
            "cpf": "U2FsdGVkX1/6lHA8jo4lkzyoePXxITCm3L/Iz25OowQ="
          }, {
            "num_cand": "U2FsdGVkX18v2yd5Btac6NADZTJ7gDzq3xos3z17W2A=",
            "cpf": "U2FsdGVkX1842QnyDwYcPnq47MXy0VjFoZzkJxlH1dk="
          }, {
            "num_cand": "U2FsdGVkX1+vwT8zMV98wVNk9c3gVTZ/PxhEbRiHoEU=",
            "cpf": "U2FsdGVkX183JR4jKedJysn1C4/kQUWT4ucg5bOZALE="
          }, {
            "num_cand": "U2FsdGVkX18YQGUj/w7i1upf9t4JD1Qetad/nHPNJMM=",
            "cpf": "U2FsdGVkX19CAw3fRcc5tMv4/EYvemek6y1JNuV0gME="
          }, {
            "num_cand": "U2FsdGVkX18UVhiX7pI93UOHxpap2hWqX2yGVFHq+jM=",
            "cpf": "U2FsdGVkX19BuTOYRpTtEfk8an5iBhJPUik2hsm9kgo="
          }, {
            "num_cand": "U2FsdGVkX1/BwR5fQ5/d99Bqzx5rJy9Pgv9uMDPjmrE=",
            "cpf": "U2FsdGVkX1+2st47IQXJ0G1/9/ado52jLqF48bzvLD8="
          }, {
            "num_cand": "U2FsdGVkX19/TJCEiPm11AciJIs920M7lcBz/vBFAVk=",
            "cpf": "U2FsdGVkX1++v91jleJAjxsDajn8X6lR6XZyGojqsDA="
          }, {
            "num_cand": "U2FsdGVkX1+rtApsARTuGgduH7scOpo3SfBv0o2EaUQ=",
            "cpf": "U2FsdGVkX1+vNbNikb5twhIR/8CEG8bGWbiTjrhInGo="
          }, {
            "num_cand": "U2FsdGVkX1+xB8FMeyQ7N8uUwPz76LV/xkG2LHsYCHM=",
            "cpf": "U2FsdGVkX1/x4XwuHb5wEtgdniQ21Ot5J9t5kgEkc5A="
          }, {
            "num_cand": "U2FsdGVkX1+iE+lUnzFEHFIbAr2ZepsW0IAXOjsxR8I=",
            "cpf": "U2FsdGVkX1+tKf8ZuGJsGOcJw3e8F0Kg8Cqs0Aj0/78="
          }, {
            "num_cand": "U2FsdGVkX18naOyYmk3B1KGcxVc43BzkLXGcBYZdLZQ=",
            "cpf": "U2FsdGVkX19EfWOR1sPYxRLHvNCnWUxGHQ/aab+iNf4="
          }, {
            "num_cand": "U2FsdGVkX18gg9CfKSxNwUqlHDMK9F5lotknbAI/brc=",
            "cpf": "U2FsdGVkX1+JiJk29ZEhT+S+v0PWHmIHtLY5ISSa9EE="
          }, {
            "num_cand": "U2FsdGVkX190MJO6WNinWquVB9ADY/Gv9T7sE0KL8TU=",
            "cpf": "U2FsdGVkX1+2P3YBayMQyR0qGFEA+n06iqZtnQcbHMo="
          }, {
            "num_cand": "U2FsdGVkX18DZOC4D/OZw+Uo0EFFsW66YvDin1E8Fgg=",
            "cpf": "U2FsdGVkX19u6lyZpNYwxKvCYkTjDGH5pbi4t6xUP3A="
          }, {
            "num_cand": "U2FsdGVkX1/CgCc1PFFefmSsQUIyQUTb0Gz2OdJRpi4=",
            "cpf": "U2FsdGVkX191PLVwwyU6XZ0V5b5e02meG1ODzUY3DmY="
          }, {
            "num_cand": "U2FsdGVkX1/DptwbvIVdNQujTEHTYuSMeO8ufmJRe6M=",
            "cpf": "U2FsdGVkX1849qDvn5Ugh1eQA5HgPbLkj27khrdri2I="
          }, {
            "num_cand": "U2FsdGVkX19PDQhR7OXGH/vV0wM1sWkWlClJ3GOO0ek=",
            "cpf": "U2FsdGVkX19JiB0lj3lwLZj+YN/An7y+ZRwmGI03rUc="
          }, {
            "num_cand": "U2FsdGVkX1+3bipZeo5jBOhSa1+U/cttYyb0ZgCmjho=",
            "cpf": "U2FsdGVkX1+l2D/BMKYEjMwIAPWSXeV2psLO8NV9tls="
          }, {
            "num_cand": "U2FsdGVkX1+c1TVXNAySNVuoipRqbBRzbv+OhzhAUXo=",
            "cpf": "U2FsdGVkX1/SDcYle1zY5AegB2oFKWFpLf0DfmAQCRs="
          }, {
            "num_cand": "U2FsdGVkX19kSq/n8IrIik9j1eRs2b0RM6EkecQObys=",
            "cpf": "U2FsdGVkX1+8pL/ce4jMPi1zp1LapxkcYAABp/5KSS0="
          }, {
            "num_cand": "U2FsdGVkX1+cQdo/2aTqly6viusmPR1BkUxfUGNbcjY=",
            "cpf": "U2FsdGVkX18x2RjinQAWfCokH/YAL01IqbWtgRmE/jg="
          }, {
            "num_cand": "U2FsdGVkX1908zodQfF4oLaV4EFP2UkV1yCwBioSlZY=",
            "cpf": "U2FsdGVkX1/DUQ+3YMMcIQY5zdSXcr+PkBYcpT6WXjU="
          }, {
            "num_cand": "U2FsdGVkX1/gXq3cKGD5fYRNtHF9FivL9ht4/4fgKp4=",
            "cpf": "U2FsdGVkX1+a12kgsrBdq+N7pIayXzJP0JK51Ur5udc="
          }, {
            "num_cand": "U2FsdGVkX1/JcBa0G2U7EvsOTBPRWz0EMND/6tFNNKY=",
            "cpf": "U2FsdGVkX1+fpuBYJ36xldyen+mCUhzzLvv5isL5KfQ="
          }, {
            "num_cand": "U2FsdGVkX1/+bm1OlHZx+T4A8XpQediUHe2+arPyFrU=",
            "cpf": "U2FsdGVkX19Ko6M+B+YR5CeKbl3B6P5bks0a7yOE1A0="
          }, {
            "num_cand": "U2FsdGVkX19QG9w7jZSEKK+UZm9zzi3BVD8Mz+UtZKs=",
            "cpf": "U2FsdGVkX1+H2WWJjZQ3jO7ZIqfL8YTUoMBVurNEwLw="
          }, {
            "num_cand": "U2FsdGVkX1+NCfWiznlDeCttHOXir6IMlVZPON9FUyU=",
            "cpf": "U2FsdGVkX1+rIAFIJPgLeWTXOgWj/D3zQ4XcFnTSZU4="
          }, {
            "num_cand": "U2FsdGVkX189W7ivsN6/S3Yxjhr26jCMMSSMK5Hc5+o=",
            "cpf": "U2FsdGVkX19fRrZHunIA8P8iuV2zDKl9XnlFAFsDQXI="
          }, {
            "num_cand": "U2FsdGVkX1/accGFUQUYXUeVqjtB2v+mk/ldAUy6wrA=",
            "cpf": "U2FsdGVkX18UCzwyWqQFzUmZxgA6mXu15XKLwWoORMw="
          }, {
            "num_cand": "U2FsdGVkX18JOT+LferpCkgcQkO78lIWFb2wpd/2+2w=",
            "cpf": "U2FsdGVkX1/MsAXlusN80+mH7GkiW2jG8OXY9PQEFBY="
          }, {
            "num_cand": "U2FsdGVkX18SM7rQ0zdcv+7UjxuKqyq9Z0gJr6PzprU=",
            "cpf": "U2FsdGVkX1+mXZi1Jei79o6VKgYm8cdFKpoMgYodmYE="
          }, {
            "num_cand": "U2FsdGVkX1/Vuh+TniPg6vGwQ/G8f7y64+/xxgivcvU=",
            "cpf": "U2FsdGVkX18xNLPh/6iZlPx9Kgl0xJ84Zm/jz3xULuo="
          }, {
            "num_cand": "U2FsdGVkX1+3J1RxaCduqVE48yz2T5Pe/dU62PXojME=",
            "cpf": "U2FsdGVkX19jNtf5MlOtTUxkttli63z09Utqd3GcY1c="
          }, {
            "num_cand": "U2FsdGVkX18conGuBJ2tlNEHYAH/aFUFGEokAC8GRP8=",
            "cpf": "U2FsdGVkX19J/bW4epWn65URm9loT2hauvez21XyBe8="
          }, {
            "num_cand": "U2FsdGVkX18Elcd1iRBp7dlYzhr/H09jQIibZ8YIsQs=",
            "cpf": "U2FsdGVkX1/bWBMsqzkI6iZiSk7dvqOe0T3EU1na4kg="
          }, {
            "num_cand": "U2FsdGVkX19d8pvVTiWd9H6LR7FWVmJzPR1WQG29aOY=",
            "cpf": "U2FsdGVkX18th6gYBZ2GRVFGZe4GeZlYbX/zWAprDYE="
          }, {
            "num_cand": "U2FsdGVkX18d4yfLSgVOqXaRpstM9e2XhOvXGaF5+0g=",
            "cpf": "U2FsdGVkX1/Oo2/j+PuSC4XzxxIbDK8fW4/Toa85myE="
          }, {
            "num_cand": "U2FsdGVkX1+1BT7Ro43vI4yjoxc4cO9vCMGB1b66T0k=",
            "cpf": "U2FsdGVkX1/3+E7HvO1UmgzCNuYK04F1FrvqNZ+4y8s="
          }, {
            "num_cand": "U2FsdGVkX19OcoeBu5bAdS48F08+McEO5IH8m42KSnQ=",
            "cpf": "U2FsdGVkX1/E/LMpRP8t/fHIoxrS+U+4VE6wIFd7lQk="
          }, {
            "num_cand": "U2FsdGVkX18NwItG6qDCUcetRuwpYPE4MklrUFy1uoA=",
            "cpf": "U2FsdGVkX1/LFXa9yyoqWYpDUU4WKZt0rXZ6cjXxzi4="
          }, {
            "num_cand": "U2FsdGVkX1/iH2c2EwN6RJR4nOzy0yvsrK9GPjpDoAE=",
            "cpf": "U2FsdGVkX1/Z4Q8S6Q22Ec6EfBLF0q5B/6pfpgFm2+4="
          }, {
            "num_cand": "U2FsdGVkX18kIQ6aeikRRiA/BAqmBVojheq0A2pOhRo=",
            "cpf": "U2FsdGVkX18AreOZWs97MbKpTj/H1oAAkO5eSzNYg3s="
          }, {
            "num_cand": "U2FsdGVkX1/chZzvTYwY6XZNxx50LlPBfCWRY3g4tk4=",
            "cpf": "U2FsdGVkX1/UcnbCcwjQtwHVTaoVyEJT/ZjONjhX1zI="
          }, {
            "num_cand": "U2FsdGVkX1/pvnfgTnzw5LGHZ7Y7C0OTxQbIEjvQ9fI=",
            "cpf": "U2FsdGVkX18y+MGSXP2MDo79itjY6uf2nZP/qqmS+TU="
          }, {
            "num_cand": "U2FsdGVkX19eL5JKO1Ak0BLSmj7H5kdgoKKbEv7mnts=",
            "cpf": "U2FsdGVkX1+Jt8FHvUkzogFZ41oOeJTZH1fNHHGB+OU="
          }, {
            "num_cand": "U2FsdGVkX1//D3Pal+jrkI01S3rXoJ/ZiorvDH2eyHI=",
            "cpf": "U2FsdGVkX19NVknwdFiXIQejt5zjElftGbde4L7QFRk="
          }, {
            "num_cand": "U2FsdGVkX1/z4a/O0HRoHRxaWmniQWPQQo61mDLNENA=",
            "cpf": "U2FsdGVkX19aq6vjDLGbdjR6T6m+fOONEcG3PQKPasU="
          }, {
            "num_cand": "U2FsdGVkX1/hvR5OVjDpJHCXI/K86w3EyIAfBIqe5RY=",
            "cpf": "U2FsdGVkX1+plkf2TDqJt6bR8Hy7i2RNSZRxmcqBS2M="
          }, {
            "num_cand": "U2FsdGVkX19TQfJP2nPoivy771m4Lxe6LEQqMr7rjRc=",
            "cpf": "U2FsdGVkX1+7Oyoh8FDSg2U6trQ92HMOMHC1PFf42C0="
          }, {
            "num_cand": "U2FsdGVkX1/jxlweu+TVlEd3RQRaGGfaQxIEpXPmE7c=",
            "cpf": "U2FsdGVkX19eYqSAzlSIVACAEB7Buj05em8F2SHToCQ="
          }, {
            "num_cand": "U2FsdGVkX19H7zO40mpYB4Kbi6QjltQO1eX7Sww0Xhc=",
            "cpf": "U2FsdGVkX182clNrclGUpVznPt9g6eQVwc0LNxg8v90="
          }, {
            "num_cand": "U2FsdGVkX1/HrYswkSvC/dCHXb4jH85NmXYG/pIsBRI=",
            "cpf": "U2FsdGVkX18Dp/XWjWedriiWw4FGpwcmuIjmtMRZUDA="
          }, {
            "num_cand": "U2FsdGVkX1/qxFpVX9IBTrYeOinD7psTgRoQEjRdgtw=",
            "cpf": "U2FsdGVkX1+nPPH6qjUW/8DDFylgE+QeIKMm3DpRhQs="
          }, {
            "num_cand": "U2FsdGVkX1+IIBlucQ7RP+YnIdkfTXGQJkLZUNqoA3E=",
            "cpf": "U2FsdGVkX189G4LlDI9scmvAhYtSvpcch8TE7dcvzwo="
          }, {
            "num_cand": "U2FsdGVkX18WpRxo8p2n5U2mMrYwx4dG3pETVdxFpD4=",
            "cpf": "U2FsdGVkX1+LCKiE7TVcwhzW4/67sRm3dYWs5tRi7aU="
          }, {
            "num_cand": "U2FsdGVkX1+a/BZ1J85FmaMVLGYhjybtRJIUDxISohs=",
            "cpf": "U2FsdGVkX1+GC3blRw4dSLWP/waT+i9vWaszMCv7fYE="
          }, {
            "num_cand": "U2FsdGVkX18IZeLWT1eeipb5BnnZPUbnPHYSOSzvUX8=",
            "cpf": "U2FsdGVkX193AQWWlzVNF1A/Q/nz/qzl4I+EhAuvtZY="
          }, {
            "num_cand": "U2FsdGVkX1+xydZY3JFLQ9UDXdq6IWUFdM53PAEvOa0=",
            "cpf": "U2FsdGVkX1/vEbGJWDr1fUvBRY4sSzWbMqvsRp6NlQc="
          }, {
            "num_cand": "U2FsdGVkX1+dxshrFb/u1LhgDHWHiKhWCxPEaZg9Muk=",
            "cpf": "U2FsdGVkX18CYoAjZXckbX4icCyLqPa4B/TCViiuWPU="
          }, {
            "num_cand": "U2FsdGVkX1/yijwisehkh0guQjYyd4xFKniwrkgIar4=",
            "cpf": "U2FsdGVkX1/JSA+joVhNZutsEvvBP1xxvP6jaNvnzCU="
          }, {
            "num_cand": "U2FsdGVkX1+/Lbn5EN+2LdSKa2WcXXTnbvfhIU7vE/s=",
            "cpf": "U2FsdGVkX1/yaMtVAlqWLd3ERAu6DWLX1e0obs9H1/A="
          }, {
            "num_cand": "U2FsdGVkX1/t5kQAXCoBeUEDuXsgPeAoM6HI5IAiWDs=",
            "cpf": "U2FsdGVkX19a0Itd10xyoZ3rVUnRWR27TabE/f3RaaM="
          }, {
            "num_cand": "U2FsdGVkX19yfdl44bgVEc+b2eF9JcgQIDDAZtnezA0=",
            "cpf": "U2FsdGVkX19HIteJEq3YI4Fv1oJt7B/CBVjxtWvcoJk="
          }, {
            "num_cand": "U2FsdGVkX1+5o1ousjx636MQcbhxPdGc/9ei8RueQeo=",
            "cpf": "U2FsdGVkX197I5hUtfX8ASL60m7+P8KBePPKAGrepSk="
          }, {
            "num_cand": "U2FsdGVkX19FYc8vCcFsCENN6E0TzOw9YubR5C0dFxA=",
            "cpf": "U2FsdGVkX1+zFXp7hKRJqrV2HZwuNM8vbDhzjZoT6rc="
          }, {
            "num_cand": "U2FsdGVkX1/ZWhvj/aJ0aPbLEvbOEkSKE4XSl7wBGKM=",
            "cpf": "U2FsdGVkX1+p/XNiHMFLjy1CaWKqdDi+lK5tsDuP24c="
          }, {
            "num_cand": "U2FsdGVkX1+diAyBBh+v7ciehZq0aGZNT4E0iPopT9w=",
            "cpf": "U2FsdGVkX1+rOOj5Vy7dA2MmFzxKIIPPpIllyRdBf8k="
          }, {
            "num_cand": "U2FsdGVkX1/gKs7COHIbg+DzRum9DVAACMdniweN4xo=",
            "cpf": "U2FsdGVkX19dm57X3sgiIKP8OsIhL8JKCr8YkEtOAdw="
          }, {
            "num_cand": "U2FsdGVkX19qoBhrgFyCFlt18ilwRf8Iwx0ppIyjBKA=",
            "cpf": "U2FsdGVkX186c2JnzcewVChXKme01B1xQpRhL2nSuUE="
          }, {
            "num_cand": "U2FsdGVkX1+c+fefgAeCtUR/lDLnjksS5gKTxwpHwLo=",
            "cpf": "U2FsdGVkX18H3zm2HhdblpLml26MKycwSCsCkD9RldE="
          }, {
            "num_cand": "U2FsdGVkX1/ruvbRKp6+cgG6Qw728bE9wI+Upt6IPko=",
            "cpf": "U2FsdGVkX183jYBpPNsAKMqBHt1NTvgfSVm/ZsB0OFg="
          }, {
            "num_cand": "U2FsdGVkX18qYVCGEUPBXYtDr2f5RETn/Q7s1K2qcmc=",
            "cpf": "U2FsdGVkX19KDPU3IpqrWRDyO4TlQGnqzD7GYFbHmu8="
          }, {
            "num_cand": "U2FsdGVkX180BoElQWBuVkZ2zTf0sAS6/oki6Sgm5Ns=",
            "cpf": "U2FsdGVkX1/S42bOhcauRGVkUQA7umOPTu3dD4l/Puk="
          }, {
            "num_cand": "U2FsdGVkX19Ao+dJMUhHJO4y/Ox9Lbnh1VW7oxRVR5E=",
            "cpf": "U2FsdGVkX1/Gs68/k9OBYY6zYn2lEJbQYL0oROcLbeQ="
          }, {
            "num_cand": "U2FsdGVkX1/qG7bTwKj/YIeodSX4Bitb0PbVaj+Ws0Q=",
            "cpf": "U2FsdGVkX19gFTiksb7OrYcaqB8BoipcSFvI/OD54AI="
          }, {
            "num_cand": "U2FsdGVkX18nc8ARz2PzRSwrsOMC2I9whYVUgXgL0+g=",
            "cpf": "U2FsdGVkX1+B8s97wtAaUlz0B87wdGFYiUTkV18fzDU="
          }, {
            "num_cand": "U2FsdGVkX19bMaLexrXS8BnWEFcy5v8+s+8AiiN/Xz8=",
            "cpf": "U2FsdGVkX1/c2T2S3VLhbbM8bJGpbdNf1ymb0RN3KzA="
          }, {
            "num_cand": "U2FsdGVkX1+mBJxylo+xArb/0LZ+vUhzLGnDJRn4yOY=",
            "cpf": "U2FsdGVkX186/VNU8eH0ixaEzY+NQt1omUC/LwyUNZ4="
          }, {
            "num_cand": "U2FsdGVkX1/5TDVyf9J702/qmgRbNjS4JJosHY30Hvc=",
            "cpf": "U2FsdGVkX1/GK+AbRIfwEhqaBWWoLaDT4i4sTBF4Iis="
          }, {
            "num_cand": "U2FsdGVkX1+aaIzhPHNGoAVpU3J/VKKOeiw3C9UN+I8=",
            "cpf": "U2FsdGVkX19jXKiNmndscCZ+KOsLH6W5OJW8xLi8ADU="
          }, {
            "num_cand": "U2FsdGVkX1+tjHX3b0Lmu9Lad8oN/W6gZ7zxn3AHcGI=",
            "cpf": "U2FsdGVkX1+DpVh2X2VRddCg6GnGuHyBs2p7o8Nd5Tc="
          }, {
            "num_cand": "U2FsdGVkX1+rbR4lD3G+4vot0j4Pu7ztJTgK9B4J8vo=",
            "cpf": "U2FsdGVkX18sROTW7po1JPi4PIsdFv+ZIPpElpcDHIs="
          }, {
            "num_cand": "U2FsdGVkX180OezF0Ta8GxdDiCdE3Bmh+o0cxmHiwkY=",
            "cpf": "U2FsdGVkX1+phcHIpGQXjdPwIlxQ5opa6u2Cf69Zux8="
          }, {
            "num_cand": "U2FsdGVkX180/uJmtIWWYKN+bLbIKJ/pCu9z3JLDEcg=",
            "cpf": "U2FsdGVkX1/NFd/vfhoy2hVQg/8gjwUXzjI20fJxKZ4="
          }, {
            "num_cand": "U2FsdGVkX19UT0fTVm3KlFixWVXR6EaJehaYR4y8OGc=",
            "cpf": "U2FsdGVkX1+5zoecwHG92vtzN3XpjUTnzDPg//YgJKM="
          }, {
            "num_cand": "U2FsdGVkX19gzF9XgC0YWy0nUobzwsZSRwjKVatDZwY=",
            "cpf": "U2FsdGVkX191Rq2YKqsoUoafGg5o50Ks7fJf5pgpfZw="
          }, {
            "num_cand": "U2FsdGVkX1+4uq6UpY/MlDGfGuQX0SCfj87BuTe5lS8=",
            "cpf": "U2FsdGVkX1/jMqLw2hiANH+B7SaEPXBpQHz3esJykSw="
          }, {
            "num_cand": "U2FsdGVkX1/UJJPNhGO/zKktD3H+KmhpBR5asrxDGfs=",
            "cpf": "U2FsdGVkX19+5tjGQYNBf2q0YjMZJi36qpGtqu4NBK8="
          }, {
            "num_cand": "U2FsdGVkX1+L2BBTfcsHiYeHcG0TOwy0RAZ+jTsY/i0=",
            "cpf": "U2FsdGVkX18VxDpvbDbNEgfOjZLpCo4sbc6NEXVbTME="
          }, {
            "num_cand": "U2FsdGVkX1/qWUS+o9U0pl6hAnOarzwvIw2zgJYgtcI=",
            "cpf": "U2FsdGVkX19QhiWLT90zgOuYjuXYNInmQqdBQ1x7Nyw="
          }, {
            "num_cand": "U2FsdGVkX19dMNjFRAJN8iJTNOsJUG++GE1m9kcU204=",
            "cpf": "U2FsdGVkX18TgBRmf19KuDRxJz61Fv8YMJ2udEwsFiw="
          }, {
            "num_cand": "U2FsdGVkX1/4by3bO6uNqt2f1PmFJVlAhlPEG0IcPSw=",
            "cpf": "U2FsdGVkX19zhaNjIzgy4hHPlGpFBsTWMhyR+0FQeDY="
          }, {
            "num_cand": "U2FsdGVkX19jUbxDs1glRNc4VXmDwdXxPFiRdpLCw7o=",
            "cpf": "U2FsdGVkX19D44Prysxjrk3GZvlMWfs163U6TnNfmxs="
          }, {
            "num_cand": "U2FsdGVkX1/6s56ZHdLp0kO45fyiRJJrXjQY42h8LNI=",
            "cpf": "U2FsdGVkX1/+/V/ow/eA/PWItXG4z88Vl8dIhRd3/gM="
          }, {
            "num_cand": "U2FsdGVkX19N/DvI4u4FxUKQnHM9RB+RgwZ+6i9PQfY=",
            "cpf": "U2FsdGVkX18TGV4tO0wwF2nudjHqZUN+ZiYJ9pbwtIc="
          }, {
            "num_cand": "U2FsdGVkX1+iwaVYPddXSFZOdijSoTAzZSICYiI9lRU=",
            "cpf": "U2FsdGVkX1+6hSAt0NecnA/m63qR26NEEhr/e4zRqsE="
          }, {
            "num_cand": "U2FsdGVkX1+45bg4e17R+FJSH89P89ZG83ZSdg82cF0=",
            "cpf": "U2FsdGVkX196mkcKkIiR/sijdqQ57HaSY+VZH4eVZXw="
          }, {
            "num_cand": "U2FsdGVkX18JCYPSuDEK2fByoQzYyUOsaRWwcqws8wA=",
            "cpf": "U2FsdGVkX19VgpvMX/ZRQnPAuus5hVkb+tXIk+x3Mhk="
          }, {
            "num_cand": "U2FsdGVkX1+3rfSaklCzzVV4qf1O/OOocfM1qa26Kz4=",
            "cpf": "U2FsdGVkX1/lGy/gs+SyfuSTLmSglXGhwaV5NSDHma8="
          }, {
            "num_cand": "U2FsdGVkX18PXxjsaSebdlHT5Ucse9YzwARRbtcfQK8=",
            "cpf": "U2FsdGVkX1+Er/d0qNt1NwP5+GmK+xNhV88pzAHamyg="
          }, {
            "num_cand": "U2FsdGVkX18UAmntdM6B7g0QByVvkbToKEyw08RmDpU=",
            "cpf": "U2FsdGVkX18ksll58ApML/anvVSfz+56+7D1AvlUDRU="
          }, {
            "num_cand": "U2FsdGVkX1+ZhJfjwaVcsNq4l4T4yYnNttyXgpfxu4s=",
            "cpf": "U2FsdGVkX191/PXtTL28t8pc9URY3JqEshM5L9eabJc="
          }, {
            "num_cand": "U2FsdGVkX1/2k0UpptteYwiC4rUTfA+jJBFc6vEd0VM=",
            "cpf": "U2FsdGVkX18euuy1fYJfPwLF47DZEFBSB4y5fdbaqf8="
          }, {
            "num_cand": "U2FsdGVkX19kp6LCzukiD0oJ/gBiUOdD2zpZobXHUWc=",
            "cpf": "U2FsdGVkX1/jylvH59XstBk8RaQgzAR8h/2S+RybgeY="
          }, {
            "num_cand": "U2FsdGVkX18XtR9AJqrnZc6S2a0/huTroE6r+rhW7yQ=",
            "cpf": "U2FsdGVkX1/aYSbvUz87n0bpHcCBxdC76mNF8jaeYMg="
          }, {
            "num_cand": "U2FsdGVkX1/Y0yh1cTUmec4u79tgiAkPyYapdFt9kyo=",
            "cpf": "U2FsdGVkX18oPYqu4cSoknE/PX1luO63ETieBVn/5E8="
          }, {
            "num_cand": "U2FsdGVkX1/F593bIm/vffJ8XZnlIsMBwLTpa3hIf1I=",
            "cpf": "U2FsdGVkX18cP6G2k9pv+DlZqFqZFfRPz91SQ9Jzv20="
          }, {
            "num_cand": "U2FsdGVkX1+BQZKNkwELqR228lxD0SvJl5ccOPBta90=",
            "cpf": "U2FsdGVkX1/jiXc1hKYMOYBDG0NFWWbV9UAV/W1eJ/M="
          }, {
            "num_cand": "U2FsdGVkX1+zuABVvIJDCMjBb73o/3U8IQywofKTBOQ=",
            "cpf": "U2FsdGVkX1/wvc1XdcXv8zAFWH43mh1pXQgAQp69aco="
          }, {
            "num_cand": "U2FsdGVkX1+7uMWJTdNS7FKqWTzxUpwpxmRIhO0DF1s=",
            "cpf": "U2FsdGVkX1+iGWecRyLWuXdd2oPHB7d8kZBVhZZKP3Y="
          }, {
            "num_cand": "U2FsdGVkX18xzUAxLBFa18FxyffTv2akHeUjhtlwbv0=",
            "cpf": "U2FsdGVkX1/hzsct8iy6ExiXF9WoMQseP25/fKv/YS4="
          }, {
            "num_cand": "U2FsdGVkX18AG9RGXPQWk8NpnbrHl2Jgfoyzqb4rGy0=",
            "cpf": "U2FsdGVkX1+wFKxxSDEYZmVebqDSQi0hqnPpZE4jbWQ="
          }, {
            "num_cand": "U2FsdGVkX18T7Mb5VFTdzcIcQ7dWgWDwQxA6gHKdHkg=",
            "cpf": "U2FsdGVkX19CJ3CY9BbKTUbtXJ9Xx8s6DCUITEMAWmI="
          }, {
            "num_cand": "U2FsdGVkX1+5NdWF3J3ziMluXQsVYNIvAVyfuVCGXOw=",
            "cpf": "U2FsdGVkX1+S8cgLTs12T9JyjjOm/Xk6bSB/PERBxgU="
          }, {
            "num_cand": "U2FsdGVkX18eTgSFxWjxTxuAp9yV6cC7bveh1+Quq18=",
            "cpf": "U2FsdGVkX19FGMoywT+C/e+ueyR6um6PEz6vFS4Ezc4="
          }, {
            "num_cand": "U2FsdGVkX19Arp+RIDf6e55WAoCg9+6L98dStJYpGFY=",
            "cpf": "U2FsdGVkX199tsoxawAXi7/n1qbL9MmEZA5LS6CS+MU="
          }, {
            "num_cand": "U2FsdGVkX1969IrVYtkhrWzbPQQHBeA6Pd13Y6ZOEJA=",
            "cpf": "U2FsdGVkX19UOOcvUbW+Tc4Z0u9BAC5cDFhnWgsf+HM="
          }, {
            "num_cand": "U2FsdGVkX19V+jKvkv52Ki3YsfiRyLrQpWtzca9MXxk=",
            "cpf": "U2FsdGVkX1+tob9uBdACvaNGYVFPeK6UcA955/UQGTY="
          }, {
            "num_cand": "U2FsdGVkX19SyAh5Zu8DjhZfg4bSwKeGWxTW9SVsg0I=",
            "cpf": "U2FsdGVkX18mw0k7QMnE/qg1wOcIr38CZRPZqmCgQS0="
          }, {
            "num_cand": "U2FsdGVkX19+ioe0KdBYFl+Yklfz/GVwKDnr55IWgno=",
            "cpf": "U2FsdGVkX18EDE4Z/vwDQuAvsCqAaiTngvkue9n4ycA="
          }, {
            "num_cand": "U2FsdGVkX19aOwY60Ocb4vNCrcKoBhOZVhg02/cblK0=",
            "cpf": "U2FsdGVkX19HayWzTkYtKX84w1YqMRCERdPWFoXYvps="
          }, {
            "num_cand": "U2FsdGVkX18fcsLLFYlmCiyKcbnHl8CAE6f3giCOGwM=",
            "cpf": "U2FsdGVkX1+J6G+XKoVKi6XO450iBYJapIVsZ0hdrcM="
          }, {
            "num_cand": "U2FsdGVkX18oGCz3S0o2dCuHv5K5p+Ldu4KAw7b+3bE=",
            "cpf": "U2FsdGVkX1/s9STVVwDfT4h4lYkLGnHLzgxAT1jJ/fM="
          }, {
            "num_cand": "U2FsdGVkX18frIJRycMnZkED4u5ZiSOYSaEI7tMmOBo=",
            "cpf": "U2FsdGVkX1+PGCdoTmQatB1d2H/2XWxOfrq+sye+SKQ="
          }, {
            "num_cand": "U2FsdGVkX181jU6onf9Lm1neIOOzDGJyoA1z41Fjn8M=",
            "cpf": "U2FsdGVkX1+n2RM2ItJ3LpHk6ugMLdAIbqUY9rgd1y4="
          }, {
            "num_cand": "U2FsdGVkX184IgjPptv1QMi21hsHj4uxjW8vF2baoko=",
            "cpf": "U2FsdGVkX18maLjYEOWsuT/AtQ6Hy63PH6KE4jwjbgQ="
          }, {
            "num_cand": "U2FsdGVkX1+7PuWfqnArDr7Qk1Wznp4m+YuI1UBk638=",
            "cpf": "U2FsdGVkX19UdxvH4HAflR/JrXkThphG+aHmfZ5gEqQ="
          }, {
            "num_cand": "U2FsdGVkX193mC+XnU+tDfvAh73j76LGSS/rMpNAkc8=",
            "cpf": "U2FsdGVkX18d2lIZovFHzu1uteZBe2jEe+Qq22uX6MY="
          }, {
            "num_cand": "U2FsdGVkX193s6aZs07hOc2pjDIipdtU2ZGdXaW0e6U=",
            "cpf": "U2FsdGVkX1/xH5VBN38JAHLYhE3kJT+bqq5wb+OVCS8="
          }, {
            "num_cand": "U2FsdGVkX18HNnHWYuq/6IORp5NLg6RQoXJ+ldgMTAE=",
            "cpf": "U2FsdGVkX1/jAF1VulWOVkkjulfFj9Y5nNafN4B4Zv4="
          }, {
            "num_cand": "U2FsdGVkX1+hpOyZep0fd60Mi/Bowp2h6yfGh0dGtXg=",
            "cpf": "U2FsdGVkX1+qhrsmrBMk1F0V0OAUXe8kJ/cin7c74UY="
          }, {
            "num_cand": "U2FsdGVkX198tTr7x8wsd6pqBTjD9sAGm0B5wtUmNq0=",
            "cpf": "U2FsdGVkX1/Ik6N2nx68/o7FyWVbWKgkd3eILBaUqsE="
          }, {
            "num_cand": "U2FsdGVkX1+XppvlrH3mT+nSMo94Av2a2a2qBbqe38c=",
            "cpf": "U2FsdGVkX18NZKjZQ5mqWT46FYyPh9+qDrueJSqQUaQ="
          }, {
            "num_cand": "U2FsdGVkX1+djhcoTkeJNsfteq0jsHU+eQGeyTvQAo8=",
            "cpf": "U2FsdGVkX18OWp2SMN1jMfTd17mmN4nunyVr2dMR+yg="
          }, {
            "num_cand": "U2FsdGVkX1+VeKEw6S2Hi/K0Ns9tP80rd7JwsAB/DIw=",
            "cpf": "U2FsdGVkX1/WPjnpoJbX5dek3Q3voH7H4CDYqqoZ7W0="
          }, {
            "num_cand": "U2FsdGVkX1+ikUe6hPwrxzIJfdrnCx852EtlMppvekg=",
            "cpf": "U2FsdGVkX19S4cTOLU9eHB1ssha8HSirMEGACOQDBAY="
          }, {
            "num_cand": "U2FsdGVkX1/Ms3aRZRQIwl8PK2T9NIfLzGueUC13fFQ=",
            "cpf": "U2FsdGVkX19Jy5QJpQsDQkB5sIN48k3aycYJMIE97sE="
          }, {
            "num_cand": "U2FsdGVkX180zsBmr5uKjChUsx1fxGkAge1cs53ZpCc=",
            "cpf": "U2FsdGVkX1+DyzEmIzmt4+TS9zmnYLUfpOGdvzYdZRI="
          }, {
            "num_cand": "U2FsdGVkX1+6yZJjcIKPayTUUEJmQ3JUpBomQC7vQtE=",
            "cpf": "U2FsdGVkX18qo59QkzVSKh/q/mmu0tnnIRyuqgw/9B4="
          }, {
            "num_cand": "U2FsdGVkX1/qRkq4Idrb8IAqTDMok6GmlId+y5xz2Z8=",
            "cpf": "U2FsdGVkX1/be7z1palrqQoTezHKnOppHuweu4/FYjs="
          }, {
            "num_cand": "U2FsdGVkX19XZw+QXtdmwvwpmMkDWXjE14hnSwJjSEQ=",
            "cpf": "U2FsdGVkX1/CmuST23eUV6EiggyGBGKulX/e67pCnr4="
          }, {
            "num_cand": "U2FsdGVkX1+o3Y2CIrXK+3Ci84lxpBdxzSyAuwSXLyY=",
            "cpf": "U2FsdGVkX19I0sK7EkkAGvvolnPGD7ywWdiHNL66aoA="
          }, {
            "num_cand": "U2FsdGVkX18ADo4lycd4zjyIkCYWTWc3oyCloj4x4D8=",
            "cpf": "U2FsdGVkX18YkTSojtk+USBKhzbEh5JWP0IiVQDXNzs="
          }, {
            "num_cand": "U2FsdGVkX1/ORNwwRNH7Pqnmm1BuS3aaBbJRasTnKag=",
            "cpf": "U2FsdGVkX1/q+pXTCtCdKF3qpJ8TcEWgPLSnDBlqSGA="
          }, {
            "num_cand": "U2FsdGVkX19gYZoFD9cg+klLxTBZb0rh+lXxa7Bsu/E=",
            "cpf": "U2FsdGVkX1+oQ2kEkzptvT/DoW7owEKPMUsU9fdfFPU="
          }, {
            "num_cand": "U2FsdGVkX1/ZBM90qXMnM1tBTnOVN+mXf0BcJxARI7Q=",
            "cpf": "U2FsdGVkX1/jMqnRjjJLsRz4PywOsnK08OESFdmnxzw="
          }, {
            "num_cand": "U2FsdGVkX1/y04uG717W3+UMUEyUKU8qtXA4LnNxLxs=",
            "cpf": "U2FsdGVkX18FfXJG+DcV26iMTk2973L1FdUnkGZ9FeQ="
          }, {
            "num_cand": "U2FsdGVkX19xO5rGyDh5zOdNaM8nafSlCcVHV1uy+XI=",
            "cpf": "U2FsdGVkX1+dXIh9SnK9U97PQoLbmc1iMhrbidCCJOs="
          }, {
            "num_cand": "U2FsdGVkX195O8a+35b6xc8rKPV/prYRlikHYy28/pM=",
            "cpf": "U2FsdGVkX1/xBHHV6buyKDAvBHV0qF8tDwHmAI/RNaM="
          }, {
            "num_cand": "U2FsdGVkX1+1kOeqx96Q88BIPFUlDwV3ZZJLBNTMEeE=",
            "cpf": "U2FsdGVkX1/0QqPt2RnoCUuUbrRHZB8fw3sCwmbi0eY="
          }, {
            "num_cand": "U2FsdGVkX1/KoJcVB8DnTqiOCOp6IEOTpOSo2R3M4/s=",
            "cpf": "U2FsdGVkX18m8E4nEcmJ7YGY3FPPO92r3kjog082zNE="
          }, {
            "num_cand": "U2FsdGVkX1+OX6qQ6FVnSqcZQhmXzaRn6MpufWV7+e8=",
            "cpf": "U2FsdGVkX19g/3Dv7Aawoi15iN3+mChR+cppza4yJ4c="
          }, {
            "num_cand": "U2FsdGVkX1+KuPMCeGdHfw9FgkPdmMZTan3DysRtEyE=",
            "cpf": "U2FsdGVkX1+TAXY//0y23Wf3TzZyLEWwRFCDd81wJPI="
          }, {
            "num_cand": "U2FsdGVkX181iWa5OQ6nE7Rpm/vVgcOQNfuM9owpoms=",
            "cpf": "U2FsdGVkX19To0PebS/4q9fxALZZFgBZi9yts9tlLT4="
          }, {
            "num_cand": "U2FsdGVkX19voKn/MFZ0VD/hnN9MiiNLsOJCbCFGyC0=",
            "cpf": "U2FsdGVkX1/n28Ub+iU3X50ZtRmmhRj/3olVqJa1yYs="
          }, {
            "num_cand": "U2FsdGVkX18b/SmejbOibQTHnu3Ikav9Ds6/v2RTTOY=",
            "cpf": "U2FsdGVkX1/o2poUQkiL1D8i06/ByvBBQFP+QOYV46s="
          }, {
            "num_cand": "U2FsdGVkX1/pptSTOPx2lRcQs5aJYJ48WqHkGp2UDXk=",
            "cpf": "U2FsdGVkX19QPmPHbwcZK1lNePtjZhdUsIgjUoPVWQ0="
          }, {
            "num_cand": "U2FsdGVkX1+gYK6PX9M+vAC2bRfoS3DMk12fQY9PL4U=",
            "cpf": "U2FsdGVkX1/soo1uaa3Jti78l46wIiqgc76/sXY23WQ="
          }, {
            "num_cand": "U2FsdGVkX1/LvOko5vHjy9z2YYcB7wF4iNP/Qf6b/HY=",
            "cpf": "U2FsdGVkX1/IIcIHYd7SQQEAiWOGTSPkdvTXgAOAExM="
          }, {
            "num_cand": "U2FsdGVkX1/xMHHd5jA7sOb6y5usagl/bJN0SAEmBXQ=",
            "cpf": "U2FsdGVkX19Ohd985j9iy3Wb8kyKc/HpLkHboAgogPQ="
          }, {
            "num_cand": "U2FsdGVkX1+z59RVrE7s5zyAT5j5DJ4UCM/JGPvAQTU=",
            "cpf": "U2FsdGVkX19vuGMNXJpLKBp/J1TCsIsGXrpBEZQUqGM="
          }, {
            "num_cand": "U2FsdGVkX1/jglVuQWXxm2rJKTxLD+oFwST41os1W4U=",
            "cpf": "U2FsdGVkX18mp9i0ptZKeDN7zWLSiRSVCk/yrbZlp1A="
          }, {
            "num_cand": "U2FsdGVkX1/BRxwDNBkas9PD20vzB8NauBEo4Qn7BTI=",
            "cpf": "U2FsdGVkX1/KA3BqWppgFjtG2sbYrl9bQJKpkdNM4dM="
          }, {
            "num_cand": "U2FsdGVkX18HA5Hn8RjKYLlHJp2xprJTfVvIMRwJ0cQ=",
            "cpf": "U2FsdGVkX1/ugP1gnxxNC9M0Yxj6Onv2Xetm1+xLG+I="
          }, {
            "num_cand": "U2FsdGVkX18FG+XSVy9XDY/XSJKGdkSPtLl5TJk38C8=",
            "cpf": "U2FsdGVkX1+OLoTy3sdrEkmH3tKJGunnAXks8tz/CXw="
          }, {
            "num_cand": "U2FsdGVkX19UTbyEXPkTs+eISvFkiY7SuYPnYa9xiNc=",
            "cpf": "U2FsdGVkX19l3Bhtd7HbEpIyqJBsNoTP2IqiA8K7+YI="
          }, {
            "num_cand": "U2FsdGVkX1/TU10uPrYeZWBBSh3xEGPZHny93pHo7cQ=",
            "cpf": "U2FsdGVkX1+vTrAT96gxUquOMnI0kNmdga3JNLcwi0I="
          }, {
            "num_cand": "U2FsdGVkX1/1ZCEm0qmuUCGfylvF5bJir3UPsx/0cmQ=",
            "cpf": "U2FsdGVkX18ZmJwla+tzOdVrGRfzr62ZmygWADKh6Zw="
          }, {
            "num_cand": "U2FsdGVkX18yhZTQrEvvPGL7JbmXFqordq9O82LqWIY=",
            "cpf": "U2FsdGVkX1/l6srPxwz9dcE6pdYAerkGmJ9X6YymXl8="
          }, {
            "num_cand": "U2FsdGVkX19gR5yt7v8tUF18LnxHw7m8MkDJctiZmSk=",
            "cpf": "U2FsdGVkX1/pUUBqcLA/xBZZbycsnovmbY/78KnK1Fs="
          }, {
            "num_cand": "U2FsdGVkX1+SPeNs1ER0ZnDIBnyKVJG66d/JLn6a9/Y=",
            "cpf": "U2FsdGVkX1+XBEOkyXYsWe55eWPQDh5v11JhVJant7s="
          }, {
            "num_cand": "U2FsdGVkX18mi+Pj2eVm/yVtreyakuUoccmRF0GRPqs=",
            "cpf": "U2FsdGVkX1/KrSeydr0s3ijJQOCl5Qu4bRYiKV3eVDU="
          }, {
            "num_cand": "U2FsdGVkX19xDKApj491BKgjiOF8FJXTb2IonTtIAY8=",
            "cpf": "U2FsdGVkX1/poqZY/BYMZftZg4cBIVyMd7xxrLM1QNc="
          }, {
            "num_cand": "U2FsdGVkX18PcYMcD7Zp5k6uddzqrogQCTsUiDfQ96E=",
            "cpf": "U2FsdGVkX1+Qr+yYqRgTi9krhuGsCgTT0jlfzF3I1/k="
          }, {
            "num_cand": "U2FsdGVkX191VAsWt2VVHN/kZeQLeT+BVPlmVbmDyCo=",
            "cpf": "U2FsdGVkX1+/AE5VNgH0M9Nxi6fL7vN0JiqVpJkUVFc="
          }, {
            "num_cand": "U2FsdGVkX19OcoJ/nP42qVR/vZAxF+7CUv7vKXq3bu0=",
            "cpf": "U2FsdGVkX197XKv/YsanDquRjjPOWsxc6h8jw18wx70="
          }, {
            "num_cand": "U2FsdGVkX1+N51M9CZqZjHMgRNR6oPVfldo8xE/bYGc=",
            "cpf": "U2FsdGVkX18aIF72hTWbFOPRQ2V6VmgFIqOjo6W+7eE="
          }, {
            "num_cand": "U2FsdGVkX1+bz4olaUBLAF7AF8wnG7D0hrVoaFdvtT8=",
            "cpf": "U2FsdGVkX18Y/pOp3YnwOFkqcIS/20rT4AsNhqOdYZ8="
          }, {
            "num_cand": "U2FsdGVkX19BAnKcIEPu5fb3QT2z0KtUxRQVTh3DsS4=",
            "cpf": "U2FsdGVkX1/6diFhBd0/HCD79oRDxnRS0HRMg+vOOKo="
          }, {
            "num_cand": "U2FsdGVkX1+mbcA56XEK9OlR0K4qO8EeJFsCbIRAvx0=",
            "cpf": "U2FsdGVkX18Lqyk4zLsMOqhkItyG/V8hYbd2m6ELAKg="
          }, {
            "num_cand": "U2FsdGVkX19/c6P/9Foes2OnisPJdmyBe0al13KNgec=",
            "cpf": "U2FsdGVkX1/wcLhfgvnhwPPjJxcBBqRkthNQTJzpS3I="
          }, {
            "num_cand": "U2FsdGVkX1+sbwX29qmGLhkewCqSjEnH5MD7gd1WSOs=",
            "cpf": "U2FsdGVkX1/6Fv/SBIqOEOiNExKudZ4HxnJrlB3kiSU="
          }, {
            "num_cand": "U2FsdGVkX1+QIXI3OSvPxVCNxAur0f6qkV4wBiwA2FA=",
            "cpf": "U2FsdGVkX1/9FZSIov7AlM+xAA6hxh8NHGaQS4Px7+w="
          }, {
            "num_cand": "U2FsdGVkX18vo244REma2EYtez+T35/CdMkgfSJN1Rg=",
            "cpf": "U2FsdGVkX19dNilBsh/Hecan5oFqZKIC20vclLdpdos="
          }, {
            "num_cand": "U2FsdGVkX18mcWhaXV0VgXWUCJ67pN7bWgt83grTIUQ=",
            "cpf": "U2FsdGVkX18rVFfPcGUXHQhnzsWdsvLjQ949tB4ls48="
          }, {
            "num_cand": "U2FsdGVkX1+eGrPesm6KOOLFk9h7HNWSpex3Rr6YM9A=",
            "cpf": "U2FsdGVkX1+C6IS6IsF78q//0w3uOSP3+009v+/YNKA="
          }, {
            "num_cand": "U2FsdGVkX19xLbwmlTxQMA8PfvGuYZP06sXesUI+N28=",
            "cpf": "U2FsdGVkX1+P8sz1mx8xpMwT5+HREjpfYNcNnMExL5o="
          }, {
            "num_cand": "U2FsdGVkX19oowsNE/bd8h9haLJNWxZYx5YBXg6Z1Z8=",
            "cpf": "U2FsdGVkX1+sVHyBUoX8JkhDmBNGpV9MVcQCpWzoKfU="
          }, {
            "num_cand": "U2FsdGVkX1/TEZkwFuLxaCnCvb3a77IbKESbwXG6TgA=",
            "cpf": "U2FsdGVkX1+0Aj4TLvl6cP2PVrHsiYCIV0T4iYqT9o4="
          }, {
            "num_cand": "U2FsdGVkX18s5lrVpjhYqEEUykRn7QzDqz9k3ZU/uwk=",
            "cpf": "U2FsdGVkX1/Iy28VuPJJmn8yLAtICdhnLk5rBnOIaJw="
          }, {
            "num_cand": "U2FsdGVkX1+4Z88YSB8lP5I14DA4aIQ64BGHVl/gzr0=",
            "cpf": "U2FsdGVkX18Nz+K/jiV8b2JvrMe/0EV489znzWBnJ2E="
          }, {
            "num_cand": "U2FsdGVkX18NPdSBp4m7xj0aRPa6XOdnWJclbB3R7xk=",
            "cpf": "U2FsdGVkX18yV8LRx9f/JfCLyeeeV6ACXwGauAq+3Ik="
          }, {
            "num_cand": "U2FsdGVkX1/5/06F+MKjOA7ADdqij6pOeZLGVc9ChSM=",
            "cpf": "U2FsdGVkX1/RSnHAxR8ZV3iUTcZuiy2+mCeIXn0nATA="
          }, {
            "num_cand": "U2FsdGVkX19EHV6LJU+EoG5eVxXocU5f+z6p0M2BqrM=",
            "cpf": "U2FsdGVkX19RehOSRXpGd7rCdxWfNf89LLh6EEZYRPM="
          }, {
            "num_cand": "U2FsdGVkX1+yQl4meL66Im9aVr8GF8xCl4z/RhHmIAc=",
            "cpf": "U2FsdGVkX1/o+Evsv1hgGzFBE3r0r46w3LRYGz7htBo="
          }, {
            "num_cand": "U2FsdGVkX1+xboqibzKcjEBstbbSrZCzz5YDsxfVU1k=",
            "cpf": "U2FsdGVkX18GtWN1BOQ5oIn06XPff6Npo+4/3IdrkgE="
          }, {
            "num_cand": "U2FsdGVkX19Xyu6ydMsuyL0X3SHmeAMJwCVlbBoQlR0=",
            "cpf": "U2FsdGVkX19PsJvFJ/4UdfcMybQ0l2Jo4CxrbbcR/v0="
          }, {
            "num_cand": "U2FsdGVkX1+gb3KF5XRplw7y6wKGTu2WIPqUP8Ivqbo=",
            "cpf": "U2FsdGVkX19SfPXECwoA1TDDh6dsRKDuakCEJoA4WFo="
          }, {
            "num_cand": "U2FsdGVkX191lQ3GKSbNvMV2ajeGnMwW24KvxaF4rrw=",
            "cpf": "U2FsdGVkX199UxaJnCsnz0Jv6gckb0COU8/PMeLCnPg="
          }, {
            "num_cand": "U2FsdGVkX19xv8niSekSU9bQ3cN6yLuSRi3zU2Q8koY=",
            "cpf": "U2FsdGVkX1/SekKM3Dptfx0PrOw36+EDHTi3K1iRCX0="
          }, {
            "num_cand": "U2FsdGVkX1+EEjZSN0XUs2G29I93qH2aCw6TSFfU9J4=",
            "cpf": "U2FsdGVkX1+2X3fpe5wHoQaEFt7+gc3Hfl1VB0qoUis="
          }, {
            "num_cand": "U2FsdGVkX18i2lzk3rd4BKDUL3edw0uFoy3Po9NX3DE=",
            "cpf": "U2FsdGVkX1/cfh/0KUe6j+kw9RA2zODdFwKaSazJNlY="
          }, {
            "num_cand": "U2FsdGVkX1+yTRd1NhWVrMb3OoTj2s2kt7Z6LhmrK4Q=",
            "cpf": "U2FsdGVkX19yIEpEizkT+LrahlP33TzCZ/MsK2ySFKw="
          }, {
            "num_cand": "U2FsdGVkX180xfTCq3sc2vt/+Ui8bbQnwDf3MgtPXBc=",
            "cpf": "U2FsdGVkX18jXerPOHhWIPMGOPKxFMItPKwzZ0ALdHg="
          }, {
            "num_cand": "U2FsdGVkX184GLywj7Fpo9ugcJwEnR5Y26ECIELLmUQ=",
            "cpf": "U2FsdGVkX1/VJPW6rXTux8Op8S4We8OxrJcZ9HTleG8="
          }, {
            "num_cand": "U2FsdGVkX1/g5mUE21cSkkb7s5nNNexwazQYhxm5PhU=",
            "cpf": "U2FsdGVkX18Q1rOYByyrqrxLyRkLCIpsizKAzLAT4mE="
          }, {
            "num_cand": "U2FsdGVkX1/b241JEfjx+wce7+uYqi94NfuyCHaSf98=",
            "cpf": "U2FsdGVkX1/Jpz14GiqHq5Z0UK0/LTHc6uXkKtWfFA4="
          }, {
            "num_cand": "U2FsdGVkX18v6PflqmSMA2oezJdJTmXnhLrEDs4GdW4=",
            "cpf": "U2FsdGVkX1/IsZdKKGGhf2R0XW0RygWqpKRsALd7g/A="
          }, {
            "num_cand": "U2FsdGVkX180DkaSRjphn0dak1kdV+2Qukuqsfsp4Xg=",
            "cpf": "U2FsdGVkX1+lewq2LfNhJtrNo+x3Bnc+NLnQKVn38vk="
          }, {
            "num_cand": "U2FsdGVkX18aToCYKWb48op8h5ehlvWpxgSCQGYuvbM=",
            "cpf": "U2FsdGVkX1+q2dn9i+9j7AlM4vegPl1qF+pEP3KLj7E="
          }, {
            "num_cand": "U2FsdGVkX19n3hH4ASFXJ0iO4bMEL9lMQRUQuTafJNY=",
            "cpf": "U2FsdGVkX19fnBnOy44qKhmNc4zvWLmMrG3nS0dbyIQ="
          }, {
            "num_cand": "U2FsdGVkX1/IzM9nbtHKixgEreBP54mXD+9+UOE8ZSs=",
            "cpf": "U2FsdGVkX18UpvYRYtTR3FisVmv5lXqDVVz0ZRcOX24="
          }, {
            "num_cand": "U2FsdGVkX1+AzoI40d5F4UYPhcj/9x4QJj9R6ElHAOY=",
            "cpf": "U2FsdGVkX19aHcRy+hPQb0WAEg/fXBnKeJYF3YOAmog="
          }, {
            "num_cand": "U2FsdGVkX1+81fmgF3duHdT620tKIkFPrgaWwlBbGrc=",
            "cpf": "U2FsdGVkX1/HLXfAB0BqfDNP0qfyOJbJ2E8VJ6xMn+U="
          }, {
            "num_cand": "U2FsdGVkX1/yJJWeGSOGgZ/oAPcVreHHNi1ZcdcU93w=",
            "cpf": "U2FsdGVkX19pXOnJMzDIhVjl4ICEbhLNXo5DNeK/7ZY="
          }, {
            "num_cand": "U2FsdGVkX1+0bUj0GqArrx2rOpPualMVVBu6mzuJRHw=",
            "cpf": "U2FsdGVkX1/zMQ54hO0gcB0zbakiIggEh5ZhUZjLc4E="
          }, {
            "num_cand": "U2FsdGVkX1/7GvjkhD88Brz5cOciXZes1N7iEgxT5mI=",
            "cpf": "U2FsdGVkX19FNTiS7DVQpnn9yubgJt2VsSCZEKNjfRE="
          }, {
            "num_cand": "U2FsdGVkX1/lHaY2NQCqNZSspW+V8M1RvFRbKLqkIT8=",
            "cpf": "U2FsdGVkX1+dx82ycMwWKtnLOb6jy2dADhMgMoyj4K4="
          }, {
            "num_cand": "U2FsdGVkX18Rw1wRz7ktKjSxGmi3wuhd3HtdKPF3kuM=",
            "cpf": "U2FsdGVkX1+Lh6lsclNvmwR6XO7OBTcyXeCV80/H1bM="
          }, {
            "num_cand": "U2FsdGVkX1/OjBwsGZhw3w2ShzTyUj6Yc51HPLBoneY=",
            "cpf": "U2FsdGVkX19JHENzDs76E0FcXx0+0lVKZQsRa9ED9qE="
          }, {
            "num_cand": "U2FsdGVkX19QRdALnwTOzAkRAYjxn5ZP9du8v2Un5pM=",
            "cpf": "U2FsdGVkX19Ulnixf5E+E6d7O84yunZ7ZzBp7w38Z18="
          }, {
            "num_cand": "U2FsdGVkX185GUNKCMBOwqzXyXBjTaFuUvYUezl3whU=",
            "cpf": "U2FsdGVkX1854hHte6C5Jn36GVYMHV7gknVUPO8/W+o="
          }, {
            "num_cand": "U2FsdGVkX1/W283RNyZaTmVxIErYbAlEFzunwW1ITh8=",
            "cpf": "U2FsdGVkX1+tDNOVZzMfnUzWRAdI2o1Z0V2F3EYpDaU="
          }, {
            "num_cand": "U2FsdGVkX1+dgBVTysKxKkigzHy8fz0GAjiEqjKJrgo=",
            "cpf": "U2FsdGVkX19eR+v1Vycb/xSwqIVGKKKfAmN6wTQyr/Q="
          }, {
            "num_cand": "U2FsdGVkX196tw82ROSbk+dokrVnKJQMHcgmvfjmx7Y=",
            "cpf": "U2FsdGVkX191Qu2tYGyQigEEZqpj6n99QL5cemMYH0Q="
          }, {
            "num_cand": "U2FsdGVkX1/JjEbUcLjI9iuA1hFXH2JjZvlUof9yPV8=",
            "cpf": "U2FsdGVkX19luLBfxG2uuiwGnaGUShYtgCtkal3DyHg="
          }, {
            "num_cand": "U2FsdGVkX1+NMEexw1PKZj8Xmsfs29w2zrtIWMQwr/I=",
            "cpf": "U2FsdGVkX1+XdwHK+kLneo4wdtDRD5IfQWKSsk0oEQw="
          }, {
            "num_cand": "U2FsdGVkX19EwXkN6KL2YsjGXDLTgqZa1HbmQjKCMgg=",
            "cpf": "U2FsdGVkX18ntJ8KQ09PAQy+IKtRV1mJ9ue+cHdQlcY="
          }, {
            "num_cand": "U2FsdGVkX1/XLY2TSMWOH+epvwBWArUFz9IxwGN69pk=",
            "cpf": "U2FsdGVkX1/kUPx1uDwlQZwliX2w6NOkycPrCVyueb4="
          }, {
            "num_cand": "U2FsdGVkX1+5Ci3JLGn4V8+vT+r+4IG6pbNSxT1TnWk=",
            "cpf": "U2FsdGVkX19JmzhLIk4eiu3mLthvKR2QoggvSUX/I4Y="
          }, {
            "num_cand": "U2FsdGVkX1+zNgU0+WSKDFSvAvGA0o8z4rPAdvHI8zc=",
            "cpf": "U2FsdGVkX18MxFJ5CBbW2Hv0y+APmX2+O1VDY/5HQh8="
          }, {
            "num_cand": "U2FsdGVkX1+MpE/kkD+DPyOVIERUYTVXNU0qqS7Gf54=",
            "cpf": "U2FsdGVkX18Qvva8IZPF34+TQTkWVZvS5uilcKVl7tI="
          }, {
            "num_cand": "U2FsdGVkX18Z6QeVgu7f4bbFSRC8Sn7TrDYwfXfmPdQ=",
            "cpf": "U2FsdGVkX1/t/mtRJs6nPFHckR25MdtoDF1tN0N4MMw="
          }, {
            "num_cand": "U2FsdGVkX199X9OC+dPk8GFE/IEr5gsT3Mbso4ttKAU=",
            "cpf": "U2FsdGVkX1+T8Jc2o+r7yPFiYLVQY91h3bFbNj5RIEc="
          }, {
            "num_cand": "U2FsdGVkX19IiAnah+trV3Q88TEMqkhta5FOWfEx9Ns=",
            "cpf": "U2FsdGVkX19bD++ex3+0i0ZD7pUGU605dBdrzRD/jcw="
          }, {
            "num_cand": "U2FsdGVkX19Y+mCVIWKNFGQV/49EnsMzDcjnQadFNfw=",
            "cpf": "U2FsdGVkX19FhMaIR/rdNwiRINiHJPWAuhJjCk22YZ4="
          }, {
            "num_cand": "U2FsdGVkX1+DjLPfy3Ps4T6IY4WJjkBCcRtZ6LxcPj0=",
            "cpf": "U2FsdGVkX19HWlfOFouSM1pChVlN9pWuGdkRK5CaQuY="
          }, {
            "num_cand": "U2FsdGVkX1/GoK/VU/d7HpOrvRd9SbIJYCySikY6fA4=",
            "cpf": "U2FsdGVkX1+3MpBbrOvISCy+LeEDrcLhc0V6e3qJcs0="
          }, {
            "num_cand": "U2FsdGVkX18ronZOZHw6qCJthtJJws/zIiGoxb7/LQE=",
            "cpf": "U2FsdGVkX19WBvKtlUuJnRMaa3Ei2F/MsXdKcqObjMY="
          }, {
            "num_cand": "U2FsdGVkX1+Uohq2ScuHgQlDParG/whv+WNouPX3SaU=",
            "cpf": "U2FsdGVkX1/ciNNpJ0CD2MI/jtm7WOgzY0/mCiXAZW4="
          }, {
            "num_cand": "U2FsdGVkX1+BSGO9hraxCF1/2QyMpFtarPvrGs7wX7U=",
            "cpf": "U2FsdGVkX193fSVK0NX8U8cHlAHOp4hpmJ6+iIScL8s="
          }, {
            "num_cand": "U2FsdGVkX1/vUlYhlOj8/NW0iR7f6FLVzEomOZUkDjo=",
            "cpf": "U2FsdGVkX1+9yCAG+Y9URBmNTR+vsl6QWQqvaXLPu/o="
          }, {
            "num_cand": "U2FsdGVkX19P3OXko98GU9WuWfGxTQrMXV42x/i3Vug=",
            "cpf": "U2FsdGVkX18xM6X2LxuMpEtrt36Vm+j73dXYIeeZqhQ="
          }, {
            "num_cand": "U2FsdGVkX19UdjlWp7J928ppjxKjZQ45hYHNf3mVZlo=",
            "cpf": "U2FsdGVkX1+BhUBmSt2q6DfobLrfj0Hx0TvaMwkYpwU="
          }, {
            "num_cand": "U2FsdGVkX1+uy5K7eGFOjXzTI9uqiSRQ3TEMmQ1u0og=",
            "cpf": "U2FsdGVkX18+VhV3Fme92882IWbb9fWIOnFGmUu1LZE="
          }, {
            "num_cand": "U2FsdGVkX183JkNGiPaLvJq8D01EVecKj+8JwxgJXww=",
            "cpf": "U2FsdGVkX18Pc7pcjJ93Y5rciCfYRbjG+w4F5ucObdY="
          }, {
            "num_cand": "U2FsdGVkX1+gwQbDg5jM2qs6flRIoSToRSMHILvseVQ=",
            "cpf": "U2FsdGVkX18Z7WOz8pjiSUOCGbQu9TkIEbMNxdp7kl8="
          }, {
            "num_cand": "U2FsdGVkX1+z1lFuc/b1iYCWUWSh7cqKNCj5HhrpLN4=",
            "cpf": "U2FsdGVkX19/vWu29NJwxol6RtUQJeVTTVtYJdIFhfI="
          }, {
            "num_cand": "U2FsdGVkX1/oDFK7wkyHZyy+SzdhzRnDuMXZGOSsLkY=",
            "cpf": "U2FsdGVkX18E5YRrhZkZbeP1Mq7m5+7PffCTm/8ZmlU="
          }, {
            "num_cand": "U2FsdGVkX18A+10KMbDvK1trfA7ntkUHPjUlzKsi9Q4=",
            "cpf": "U2FsdGVkX18Sl43EXdoKjqe07elOZkBKFusas/Cocw0="
          }, {
            "num_cand": "U2FsdGVkX18//srfub+ziacMXKPh+6uz5WkD76B8SNk=",
            "cpf": "U2FsdGVkX1+zoA1XmMbYrDy1O+U3zMCvt+GlDKtdQYI="
          }, {
            "num_cand": "U2FsdGVkX18EIWC2w/OU7Jo+qU+aEGLvtJaei4qDobw=",
            "cpf": "U2FsdGVkX18aX2/nGZRySqvMqknooUZ94A4vQglLtH0="
          }, {
            "num_cand": "U2FsdGVkX1/X9UOBxrmuZfr1IQhcLv0l99WpCT2HHMk=",
            "cpf": "U2FsdGVkX1/9bAiT+UWywhMSzXvSXUSfAzyKUB3EDv4="
          }, {
            "num_cand": "U2FsdGVkX197h/UsZ1Okt24yTg2jGi93clmnOF2+xQs=",
            "cpf": "U2FsdGVkX18LR4BamCxkQzpkFD9pmLmMnmUwxay1AkY="
          }, {
            "num_cand": "U2FsdGVkX19oxpuZMd6fGEjXfoqw7F9dLBTX3TD00gg=",
            "cpf": "U2FsdGVkX1+IdPvJ/rJB3uGHdC3ArswdjMDLxf8vuvI="
          }, {
            "num_cand": "U2FsdGVkX193kVLX5lkhxu6STmxXB6ZMQkwtpy7YYiQ=",
            "cpf": "U2FsdGVkX18jFQz11ki4bQRPpNUE7RxChVOQRmkjvds="
          }, {
            "num_cand": "U2FsdGVkX18Rh519fK6TXhiuxFfEeYemArO2m0Y535E=",
            "cpf": "U2FsdGVkX1/QjQlCvyxho9yj1W3O0X+l0zcdaHZiR8Q="
          }, {
            "num_cand": "U2FsdGVkX19NbbMEp/M7zhkKEUVrr/5tL5PidmSajOo=",
            "cpf": "U2FsdGVkX19ywtHKppDMc+ZJoVS62mNcrlhz5xzwiyI="
          }, {
            "num_cand": "U2FsdGVkX1+ECxO+FvnnrYkwesoMzf2uJ+BoceiD5QQ=",
            "cpf": "U2FsdGVkX18LvGW+T8L1SS0iY6hCaDsiyMJ2SkBzruc="
          }, {
            "num_cand": "U2FsdGVkX1+AclmJNRG9l10hz6ITOwnBNRDglPfLMXw=",
            "cpf": "U2FsdGVkX1+8TTBcrYG1QzcVyX0F1cf5CCpXdUYgxb4="
          }, {
            "num_cand": "U2FsdGVkX1+33wBQptdaspybQGG0+zdv65nkxtfT1eg=",
            "cpf": "U2FsdGVkX1+YlUGqYeqQciqRY8hA08dmzXx9N8HdM7M="
          }, {
            "num_cand": "U2FsdGVkX1/hugWMQSLbdgZr9Hb0NeOvcq0R3oqu2kU=",
            "cpf": "U2FsdGVkX19vKvoBO2htNLs79ZGbz8mVjROBDiy6ThA="
          }, {
            "num_cand": "U2FsdGVkX19/yDax9gbATIfe9LPTs++elpWqthYC4U4=",
            "cpf": "U2FsdGVkX1+8gr9290QAmGBYNAyzqzoLa1ev8fAs0vE="
          }, {
            "num_cand": "U2FsdGVkX1/8A2Db7cLc/6mDyBIahw1D5JYsS6kYhSA=",
            "cpf": "U2FsdGVkX1/cPLHwGsRQVIgyHZzEf6QWegonHu9lcX4="
          }, {
            "num_cand": "U2FsdGVkX18eTJ1mPnYIOHzwlK4LTLBcBJro+PbsIQg=",
            "cpf": "U2FsdGVkX19aYR0dhl0KKBlbWqkCJTZG8FWvKL2IxWQ="
          }, {
            "num_cand": "U2FsdGVkX1/0o2eS7vq79wNFUZ1Y5uhMtz199PNQYLs=",
            "cpf": "U2FsdGVkX1+PjdEutqeX5RrGsxus1YU72HLwgCuAgcI="
          }, {
            "num_cand": "U2FsdGVkX18Ml9OjwjIL2rS8323QK6vvBH5A42Rdy9Y=",
            "cpf": "U2FsdGVkX1+s3Ze+Td04SYYEwYWOKot7TW+/bKJ5NpI="
          }, {
            "num_cand": "U2FsdGVkX19Avcb+E2DTjcP4XS59X46hWrcGP9Eziw8=",
            "cpf": "U2FsdGVkX1+o8mY8zflQ8yv5d0srbEn9Z21QDrH/Aew="
          }, {
            "num_cand": "U2FsdGVkX18dFgYJhopRqILsxSFlRLzR7/AyHnataB8=",
            "cpf": "U2FsdGVkX1+skmGc09SMjsp8XRfmmMeY56q0DLOchcM="
          }, {
            "num_cand": "U2FsdGVkX1+qXRWPVX/ZerOee816VAsbubvm7e/cnJk=",
            "cpf": "U2FsdGVkX1/I6vl7L+uTKyVGDk5a+DdNVFV6LKxzfOg="
          }, {
            "num_cand": "U2FsdGVkX193LSEGV+VE2R7RyBXITmT0yUBmNCIcv0c=",
            "cpf": "U2FsdGVkX1++TjliQgPDFp0j3ZFJ29kJQpyBpMeCgfA="
          }, {
            "num_cand": "U2FsdGVkX19urb8zwEQfcyvGBclYos12rF5wChNEvBc=",
            "cpf": "U2FsdGVkX1++jMiOzFqfbjlyzm7nmXLRL12YI6iALic="
          }, {
            "num_cand": "U2FsdGVkX18/Kuvs8LTvv1H6RdEp+90KWcTMadNcJiM=",
            "cpf": "U2FsdGVkX1/c4scA8qslKuxwp6O/VJ2BQYLnGAxvmug="
          }, {
            "num_cand": "U2FsdGVkX18QIKcispBPjQ0PFuIsSrDsj08/NZBAAJg=",
            "cpf": "U2FsdGVkX18bw/4Rg1T/kIQjOqc8XP8MzD6KKhMKZlc="
          }, {
            "num_cand": "U2FsdGVkX19LIVMjTY1WzoBRdre93K2rmn0PACMStRI=",
            "cpf": "U2FsdGVkX196HJu6MuffFZjms1b7zOBf9+qK6Epbpgg="
          }, {
            "num_cand": "U2FsdGVkX1+xFu4+53So9DydX/4qGU4DNgMACSq2l3g=",
            "cpf": "U2FsdGVkX1+GTfd3ILbCeOu3E1927hFkQgOHHKfTkn8="
          }, {
            "num_cand": "U2FsdGVkX1+Beyc0sDu/Nxd6fGycpkIFlzplKUAA0wc=",
            "cpf": "U2FsdGVkX19FI/GSmsIfbVjnWzrSwVPcQUF+Tv0aTe4="
          }, {
            "num_cand": "U2FsdGVkX1+YvSmZqG1xAEUHxKwSn+Q5xOV504/M/+E=",
            "cpf": "U2FsdGVkX1+exNDqqYk7P9VhM7HY2N99VvbrnkF5Vdw="
          }, {
            "num_cand": "U2FsdGVkX184AogSfWDp1EellGbch8kXeI3mtTIglVo=",
            "cpf": "U2FsdGVkX1/Zj4vQ6fSGv74fvDf79B7//YL+eLU1Jm8="
          }, {
            "num_cand": "U2FsdGVkX1/AEbgs5nTyZpGgxsYVd7xq4pCJtXAI43E=",
            "cpf": "U2FsdGVkX18f7MQ7/hX1hSGewdfN6SQCUJRgPWLVkm0="
          }, {
            "num_cand": "U2FsdGVkX1+3fF/+Nkh6IWDcF46fMeLinhCJ888w9OE=",
            "cpf": "U2FsdGVkX19/5RyO32VrrNU67rRfXQaVBbbcp8O3Z7Q="
          }, {
            "num_cand": "U2FsdGVkX1+DNz24rmETS1OL0DAD0f6a/ifotKUi0CQ=",
            "cpf": "U2FsdGVkX19QaWEoxJXq/hyQ1IPp6sa4gWElHBdpzv4="
          }, {
            "num_cand": "U2FsdGVkX1+B3qNamhX1y4P9TWmPBwqT8/3UODTwFk4=",
            "cpf": "U2FsdGVkX19MFu60vloJ1yFX5Y2RQ8XIPB2bxIqG3vQ="
          }, {
            "num_cand": "U2FsdGVkX1880Y/mplugvvnpdMmLNBMbLDxawrHUCz4=",
            "cpf": "U2FsdGVkX18h8TXsd+qWb8OplokJ7i2bl1ZomoZ5z/c="
          }, {
            "num_cand": "U2FsdGVkX19RSGECa5YPiXjOSN5goOuLP4ISJi154g4=",
            "cpf": "U2FsdGVkX19xmP3E4xDr+1m9A8AGTMhA7eWSpxKp3vQ="
          }, {
            "num_cand": "U2FsdGVkX1/sVDh+i+5AnR5CXjTFP51/lJIupew7cPU=",
            "cpf": "U2FsdGVkX18T42EqX3x9ApHW9gyxBb1TJoC8Io4qVVE="
          }, {
            "num_cand": "U2FsdGVkX18DXs54t0o2WYlMA8pgrDSvhgh/3SikPM8=",
            "cpf": "U2FsdGVkX18Vr0dA1peUn5M+N9mEokt+bu/xev2cBJs="
          }, {
            "num_cand": "U2FsdGVkX18V9qejernDZJnU/AZNkNt73D/nDVMqtOY=",
            "cpf": "U2FsdGVkX19pGF8RNoY4pURFqr4J71vzcZzLGaKq66s="
          }, {
            "num_cand": "U2FsdGVkX1/VPvm95TqIh1f6wnBhic8+iYjPlD1uQsI=",
            "cpf": "U2FsdGVkX1+n2jWCn9S5fDw27eYCHqHhEU+SST6CSb0="
          }, {
            "num_cand": "U2FsdGVkX18yvlhTRGzvyfmOC7qRPITTWElAQkExBBQ=",
            "cpf": "U2FsdGVkX1+hE8RTHp14edJzA9o0+VPKM+4HkrG2WCY="
          }, {
            "num_cand": "U2FsdGVkX1+xizdOcHlQe70WKh0Gg4CCgT1SMOHCpzo=",
            "cpf": "U2FsdGVkX18ccQ3i8t36SFcJC0lgDBzTpibUkCZLb5Q="
          }, {
            "num_cand": "U2FsdGVkX18iR5rLXampu+zvKv+PTKxWPdnc0ql6S8c=",
            "cpf": "U2FsdGVkX1/rIpYAKj3O8WJ4lH7gr13EiHiCsrG3948="
          }, {
            "num_cand": "U2FsdGVkX18ofLmE1ngtMaqDyC1bl7fLyUVYLXW0+i0=",
            "cpf": "U2FsdGVkX18pTxK1EOvDFgYFQ5kBP1Wg83igkp1BAk0="
          }, {
            "num_cand": "U2FsdGVkX18yToUItyuqsdQTPZtQPhcnLgwnHURr/uM=",
            "cpf": "U2FsdGVkX19CFHMrGwYLJdn+S/lP5PWKCjgn//Et3nM="
          }, {
            "num_cand": "U2FsdGVkX1/WFMnLXs5sjLdzx9TSLf2H8LC1Jgo3wuc=",
            "cpf": "U2FsdGVkX1+6pD6BSoxjcHDPbLdJ1kBaHbur3lugZlM="
          }, {
            "num_cand": "U2FsdGVkX19VkyLkLn39Pj34P71W7PMlhBV/MvRt4P0=",
            "cpf": "U2FsdGVkX1/gIrMRH8tC3MNM5dIH/XZqF3Pi7PrtHB0="
          }, {
            "num_cand": "U2FsdGVkX1+hhk+TtJz73u2qrT6zYk0oakU+ywUEejk=",
            "cpf": "U2FsdGVkX1/LaVJDHAkn4cWNO2zrUzFt24Upc/e3QfI="
          }, {
            "num_cand": "U2FsdGVkX18Or+v8EFLCnPpDl4jl7J2h3uelO2sVK5s=",
            "cpf": "U2FsdGVkX199sg+yB/H8E26yXJ1NYWWqUoAvwh8cyao="
          }, {
            "num_cand": "U2FsdGVkX18MLAN6yfeMaHWOD4s+6XfAwjGC1Hu/8KE=",
            "cpf": "U2FsdGVkX1/eDLM49vVn+zZyH+sJRz4Gwny5lhpNtlQ="
          }, {
            "num_cand": "U2FsdGVkX18stJTnNxdGG0xOBbL0ztPnaFtA7oMmi2w=",
            "cpf": "U2FsdGVkX1/ckD71/A+o2Sauzw3BHmvn+RMTtQauLHA="
          }, {
            "num_cand": "U2FsdGVkX1/wumJkDfnIZWSUllf6r8+gwOt42NG9Fkk=",
            "cpf": "U2FsdGVkX1/lz5nfqe14k74R4W3jMaZb5jSA12bo9dw="
          }, {
            "num_cand": "U2FsdGVkX1/oqCDeGz1AV6SrkDkkClnXKnAi4nkr/0c=",
            "cpf": "U2FsdGVkX1/ibpmfm+21o22VFsY+pmS5Yoaigzl1Idw="
          }, {
            "num_cand": "U2FsdGVkX18Mew3raZ4reDRuz3/fi+A1USmf5CE9LNQ=",
            "cpf": "U2FsdGVkX19bOUD9TNzoqnImhQCp+WLCMs4em7seLx0="
          }, {
            "num_cand": "U2FsdGVkX18fC7XTgEOweNuw89DvT9BIk+CsPE2ZIs8=",
            "cpf": "U2FsdGVkX18XXkjvZSLC5CeMBe1XGuJZ4M2YzhE0qiw="
          }, {
            "num_cand": "U2FsdGVkX1+TRWMmruO+Nq4uD+RBhvij4UQEzx1OfRI=",
            "cpf": "U2FsdGVkX1/V1KD5ttF4LR5uavbsvOQlku5nDV7QFA4="
          }, {
            "num_cand": "U2FsdGVkX1/zCflWtV2AaZVuo7SqK8/XC4N0/dTaQGU=",
            "cpf": "U2FsdGVkX1+u5pdAgXCMsxKO95cSPTThWOMe09sJfZs="
          }, {
            "num_cand": "U2FsdGVkX1+j5mptgiq4C8gmWdKHhc7dAtxsCvc3B+I=",
            "cpf": "U2FsdGVkX19tLY5uAa/2+0wfuTIhO2HAkRce1/aOnkA="
          }, {
            "num_cand": "U2FsdGVkX1+uENOTrYW4NqoH+cmqlCiLsFE0noqXbS0=",
            "cpf": "U2FsdGVkX19fE0Sx3vOrWQtpMK2zwKyxorWYVJ2LDjo="
          }, {
            "num_cand": "U2FsdGVkX1+HXNVkzfKR1go2e0dlbMJmztgGqwf/eUI=",
            "cpf": "U2FsdGVkX18Pp105HGd7C1sfl1b2em4zaS/hUNJxgXg="
          }, {
            "num_cand": "U2FsdGVkX19z2F8Ep0Dq6OAL1wbWbskGz7ZzqtYaxno=",
            "cpf": "U2FsdGVkX19tMrZuzTZmLOE/23Z6ZYRrlZExrQ7xeQI="
          }, {
            "num_cand": "U2FsdGVkX1//BziAd8+SnsnutY3ZH8TbC7uVvEdohAs=",
            "cpf": "U2FsdGVkX1/9RqzttEtJPPSG+xplNEzs33kphe6mJZo="
          }, {
            "num_cand": "U2FsdGVkX19iphwUUZfflNeLShzSnJMQdDXrYj6ZX6k=",
            "cpf": "U2FsdGVkX1+EtPzUyhbUDK7xwFgUQAvNTfG6ilP7L/I="
          }, {
            "num_cand": "U2FsdGVkX197/miLYrhC9UzL7kfIBqV/icXTIm224Vo=",
            "cpf": "U2FsdGVkX1/MQpFX1JCyn+83X7hLuYLsEJrXtrOmNWM="
          }, {
            "num_cand": "U2FsdGVkX19dO/nNzngUXTpvhGP+ABLQMn2E+DlQrgs=",
            "cpf": "U2FsdGVkX1+TVzqpRm6BRDuYpXSJP6e/9RS3Qv0guaE="
          }, {
            "num_cand": "U2FsdGVkX1+ddvkdAnDsvzw073TVfz3Hj3XMW0tMAno=",
            "cpf": "U2FsdGVkX18uiPUNy07UE+Vl+tck5T1dBZzGEFwMEH0="
          }, {
            "num_cand": "U2FsdGVkX18jxhQLzUn5w1DRqc7kCGcyM73DTV/BpTA=",
            "cpf": "U2FsdGVkX1/EvuyaqHnI+HCz0MIvdPBzbTDcX7InL7Y="
          }, {
            "num_cand": "U2FsdGVkX18UrqUVEaHyssbcizLL0jI76PXWHVprcPM=",
            "cpf": "U2FsdGVkX19jO7olNUFEjLcTp3Jd40t7cklHMFF/Oz8="
          }, {
            "num_cand": "U2FsdGVkX19waQNJsamLyMAG24ACggr+MaSaJ2zZugo=",
            "cpf": "U2FsdGVkX1/hHfhDaz3SLT6CHv9SSkQcdFG26TSr+xM="
          }, {
            "num_cand": "U2FsdGVkX1/hmUNdm2YAX17rfcXIKAjlWvfyX1H+1r8=",
            "cpf": "U2FsdGVkX19GsfPNjMInlodGAmonc9EYL/ixMysxwzo="
          }, {
            "num_cand": "U2FsdGVkX1/mYs+I4WWRwjF3IvZEzMQ9vzpXWuJkHxE=",
            "cpf": "U2FsdGVkX18uiBsPJotpJTcefLgMVCi1C76X+KPb+VY="
          }, {
            "num_cand": "U2FsdGVkX18qwuUyEZkMgPXavKSp9OLn1XZ1clpHAgk=",
            "cpf": "U2FsdGVkX1+/Ir5059BqIsiFP1ZqR35JC1chMqMvqJk="
          }, {
            "num_cand": "U2FsdGVkX18m7W/M0kdgfbygSXuvJiXIe7Ar960nYJk=",
            "cpf": "U2FsdGVkX18UdxiH2bsxol73dvx+nblRDBBbOsKdsus="
          }, {
            "num_cand": "U2FsdGVkX18/pmEh5OXs4DTBV25dfJRQx/0QksWgNHM=",
            "cpf": "U2FsdGVkX19Cpca0T1xjbXr60dlsMjVWcs3Mtj+42uc="
          }, {
            "num_cand": "U2FsdGVkX19L/jDglpqbgxqD+XDeYJM74KJogyCItCA=",
            "cpf": "U2FsdGVkX181WoTszR9GezncKWzYwWvzbvN7otumsL4="
          }, {
            "num_cand": "U2FsdGVkX1/02Keb69HwBGRYdRMh8VlxOlM1cQWYZfM=",
            "cpf": "U2FsdGVkX19BhKNkTQvlLzL3GYVqZDs4FDx3bOkpAV0="
          }, {
            "num_cand": "U2FsdGVkX192OjxcuZWmxNqBAQqh24PLE9/5FyWOLys=",
            "cpf": "U2FsdGVkX1+TPp8N4KfWyafDe4o1zvPomcBEnW4uEjg="
          }, {
            "num_cand": "U2FsdGVkX1+wa7dN50+v6Ya6LonCS0Ao6NO2/e3/YFM=",
            "cpf": "U2FsdGVkX19DAxW5oS9+v/cV/doQHv+JbylTgDac8Zk="
          }]


      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
          let num_cand_decripted = decrypt(login.num_cand);
          let cpf_decripted = decrypt(login.cpf);

          // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
            let nome_arquivo = (gera_file_name(cpf_decripted, num_cand_decripted))
            nome_arquivo = nome_arquivo.replace(/\x00/g, '-');


            // alert(`Logou`);
            let url = (`https://fs.ibfc.org.br/arquivos/2205/disc_nqwe/${nome_arquivo}`)
            return window.location = url;
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
